// {{{ API

const APP_NAME = _("BC4 Kalkulačka");
const APP_BASE = "/";
const API_BASE = APP_BASE + "api/";
REST.getURL = function(path) {
	return path.startsWith("/") ? path : API_BASE + path;
};

// }}}

// Application:

Application = new GW.Application({
        // {{{ Initialization

	initialLoad: true,
	
	'after:initComponent'() {
		// this.initSocket();
		this.initResponsivity();
	},

	// }}}
	// {{{ WebSocket

	socketSubscriptionTopics: null,
	socket: null,

	initSocket() {
		let me = this;

		setTimeout(this.socketCheck.bind(this), Math.round(2000 + Math.random() * 1000));

		this.socketSubscriptionTopics = [];
		this.socket = Socket({
			log(...args) {
				console.debug(...args);
			},
	
			onOpen() {
			},

			onMessage(msg) {
				msg.__origin = 'websocket';
				me.dispatchMessage(msg);

				me.detectServerVersionChange(msg);

				/*
				 * We use this message as a isOpen change hint,
				 * to notify UI about websocket status.
				 */
				if (msg.type == 'READY') {
					Application.dispatchMessage({
						type: 'CLIENT_WEBSOCKET_STATUS_CHANGE',
						ready: true,
					});

					if (me.socketSubscriptionTopics.length > 0) {
						Application.updateSocketSubscriptions();
					}

					Application.updateSocketActiveModule(true);

				}

				/**
				 * Reload session on session change (e.g. on extension change)
				 */
				if (msg.type == 'SESSION_CHANGED') {
					Application.reloadSession();
				}
			},

			onClose() {
				Application.dispatchMessage({
					type: 'CLIENT_WEBSOCKET_STATUS_CHANGE',
					ready: false,
				});
			},
		});
	},

	socketCheck() {
		// if the socket is not open and we're logged in,
		// re-open it
		if (!this.socket.isOpen() && this.session) {
			this.socket.open();
		}

		setTimeout(this.socketCheck.bind(this), Math.round(2000 + Math.random() * 1000));
	},

	socketSend(msg) {
		if (this.socket && this.socket.isReady() && this.socket.cid) {
			this.socket.send(msg);
		}
	},
	
	updateSocketSubscriptions() {
		this.socketSend({
			type: 'SUBSCRIBE',
			topics: this.socketSubscriptionTopics,
		});
	},

	updateSocketActiveModule(forceUpdate = false) {
		let activeModule = Application.getCurrentRoute().module || null;

		if (this.lastActiveModule != activeModule || forceUpdate) {
			this.lastActiveModule = activeModule;

			this.socketSend({
				type: 'ACTIVE_MODULE',
				module: activeModule,
			});
		}
	},

	socketSubscribe(topics) {
		topics = [...new Set(topics)].sort();

		if (JSON.stringify(topics) != JSON.stringify(this.socketSubscriptionTopics)) {
			this.socketSubscriptionTopics = topics;
			this.updateSocketSubscriptions();
		}
	},

	refreshSubscriptionsFromDOM() {
		let subs = Array.from(document.querySelectorAll('.js-msgbus'))
			.map(el => el.socketSubscriptions)
			.filter(subs => Array.isArray(subs))
			.flat();

		this.socketSubscribe(subs);
	},

	// }}}
	// {{{ Cards

	'after:show'() {
		this.refreshSubscriptionsFromDOM();
	},

	// }}}
	// {{{ Responsivity

	initResponsivity() {
		this.responsivityQueries = {};
		this.responsivityStatus = {};

		let style = getComputedStyle(document.documentElement);
		// Chrome doesn't return custom properties in the iterator:
		//   https://github.com/w3c/csswg-drafts/issues/1316
		// We need to list them here explicitely
		for (let css_var of ['--vp-width-breakpoint-md']) {
			if (css_var.startsWith('--vp-width-breakpoint-')) {
				let name = css_var.replace('--vp-width-breakpoint-', '');
				let val = style.getPropertyValue(css_var);

				// < rule has -0.02px in CSS, so we add it here too
				this.responsivityQueries['<' + name] = matchMedia(`screen and (max-width: calc(${val} - 0.02px))`);
				this.responsivityQueries['>' + name] = matchMedia(`screen and (min-width: ${val})`);
			}
		}

		this.responsivityQueries.prefers_dark = matchMedia(`(prefers-color-scheme: dark)`);

		for (let [query, match] of Object.entries(this.responsivityQueries)) {
			match.onchange = this.onResponsivityChange.bind(this);
		}

		// cache initial status of queries
		this.onResponsivityChangeDebounced();
	},

	onResponsivityChange(ev) {
		clearTimeout(this.responsivityTimer);
		this.responsivityTimer = setTimeout(() => {
			this.onResponsivityChangeDebounced();
		}, 250);
	},

	onResponsivityChangeDebounced() {
		let status = {};
		for (let [query, match] of Object.entries(this.responsivityQueries)) {
			status[query] = match.matches;
		}
		this.responsivityStatus = status;

		this.updateThemeTinting();

		this.dispatchMessage({type: 'RESPONSIVITY_CHANGE'});
	},

	getResponsivityMatch(query) {
		return this.responsivityStatus[query];
	},

	// }}}
	// {{{ Themes

	updateThemeTinting() {
		if (!document.body) {
			// too soon
			return;
		}

		/*
		 * Determine the current color of the nav header (it's affected by
		 * dark/light mode setting and themes) and set it to mask-icon
		 * and theme-color meta vars.
		 */
		if (!this.sourceHeaderElement) {
			this.sourceHeaderElement = document.body.gwCreateChild({
				style: 'display: none; background-color: var(--nav-header-bg)',
			});
		}

		let themeEl = document.querySelector('meta[name="theme-color"]');
		let maskIconEl = document.querySelector('link[rel="mask-icon"]');
		let targetColor = getComputedStyle(this.sourceHeaderElement).getPropertyValue('background-color');
		if (targetColor) {
			if (themeEl && targetColor !== themeEl.getAttribute('content')) {
				themeEl.setAttribute('content', targetColor);
			}

			if (maskIconEl && targetColor !== maskIconEl.getAttribute('color')) {
				maskIconEl.setAttribute('color', targetColor);
			}
		}
	},

	setDocumentTheme(theme) {
		if (!theme) {
			delete document.documentElement.dataset.theme
			localStorage.removeItem('ui-theme');
		} else {
			document.documentElement.dataset.theme = theme;
			localStorage.setItem('ui-theme', theme);
		}

		this.updateThemeTinting();
	},

	getDocumentTheme() {
		return document.documentElement.dataset.theme;
	},

	// }}}
	// {{{ Language

	setLanguage(lang) {
		document.cookie = 'language=' + lang + '; path=/; max-age=' + (60*60*24*365*5) + ';';
		location.reload();
	},

	// }}}
	// {{{ Version change notification

	serverVersion: env.VERSION,

	detectServerVersionChange(msg) {
		if (msg.type == 'READY' && msg.version != Application.serverVersion) {
			Application.serverVersion = msg.version;

			this.dispatchMessage({
				type: 'VERSION_CHANGE',
			});
		}
	},

	// }}}
	// {{{ Message bus

	busListeners: [],

	watchMessages(cb) {
		this.busListeners.push(cb);
	},

	dispatchMessage(msg) {
		setTimeout(() => {
			let watchers = Array.prototype.slice.call(document.getElementsByClassName('js-msgbus'));

			// deliver socket messages to active components
			for (let el of watchers) {
				if (el.gwComponent && el.gwComponent.onBusMessage) {
					el.gwComponent.onBusMessage(msg);
				}

				el.dispatchEvent(new CustomEvent('busmessage', {
					detail: msg,
				}));
			}

			for (let l of this.busListeners) {
				l(msg);
			}
		}, 0);
	},
	
	// }}}
	// {{{ Common route handling

	async commonRouteHandler(match) {
		//console.log('route', match);
		if (!this.session && this.initialLoad) {
			this.initialLoad = false;
			await this.reloadSession();
		}

		if (match.route.group == 'auth' && !this.session) {
			Application.route({
				path: APP_BASE + 'login',
				paramsFn() {
					return new URLSearchParams({
						redirect: location.pathname + location.search,
					});
				},
			});
			return true;
		}

		if (match.route.permission && !this.requirePermission(match.route.permission)) {
			return true;
		}
	},
	
	requirePermission(permission) {
		if (this.userHasPermission(permission)) {
			return true;
		}
		Application.notify({
			kind: 'error',
			text: _('K této části aplikace nemáte přístup'),
			priority: 5,
			timeout: 5000,
		});
		Application.replaceRoute(APP_BASE + 'dashboard');
		return false;
	},

	// }}}
	// {{{ Session

	async reloadSession() {
		let signal = Utils.abortAndRetry(this, 'reload-session');
		let session = await REST.GET('session', null, {signal});
		if (session) {
			this.session = session;

			this.onSessionReady();
		}
		return session;
	},
	onSessionReady() {
		// if (!this.socket.isOpen()) {
		// 	this.socket.open();
		// }
		
		// let the app know about session change
		Application.dispatchMessage({
			type: 'CLIENT_SESSION_CHANGE',
		});
	},

	onUnathorizedError(err) {
		delete this.session;
		PopupManager.hideAll();
		this.resolveCurrentRoute();
	},

	async login(email, password) {
		this.session = await REST.POST('session', {email, password});

		this.onSessionReady();
	},

	logoutChecks: [],
	logoutActions: [],
	
	async logout() {
		for (let check of this.logoutChecks) {
			if (await check() == 'cancel') {
				return;
			}
		}

		this.socket?.close();

		for (let action of this.logoutActions) {
			await action();
		}

		await REST.DELETE('session');
		delete this.session;

		Application.replaceRoute(APP_BASE);
	},

	// }}}
	// {{{ File DnD

	photoDropHandler(ev) {
		let files = [];

		ev.preventDefault();

		if (ev.dataTransfer.items) {
			for (let i = 0; i < ev.dataTransfer.items.length; i++) {
				if (ev.dataTransfer.items[i].kind === 'file') {
					files.push(ev.dataTransfer.items[i].getAsFile())
				}
			}
		} else {
			for (let i = 0; i < ev.dataTransfer.files.length; i++) {
				files.push(ev.dataTransfer.files[i]);
			}
		}

		if (files.length == 0) {
			Application.notify({
				kind: 'error',
				text: _('Nahrát lze pouze fotografie'),
				priority: 5,
				timeout: 3000,
			});  
		} else if (files.length != 1) {
			Application.notify({
				kind: 'error',
				text: _('Nahrát lze jen jedno foto'),
				priority: 5,
				timeout: 3000,
			});  
		} else if (files[0].size > 10000000) {
			Application.notify({
				kind: 'error',
				text: _('Limit velikosti obrázku je 10 MiB.'),
				priority: 5,
				timeout: 3000,
			});  
		} else {
			return files[0];
		}
	},

	// }}}
	// {{{ App startup

	'before:run'() {
		let theme = localStorage.getItem('ui-theme');
		if (theme && ['light', 'dark'].includes(theme)) {
			document.documentElement.classList.toggle('no-transitions', true);
			document.documentElement.dataset.theme = theme;
			requestAnimationFrame(() => {
				document.documentElement.classList.toggle('no-transitions', false);
			});
		}

		// Removes meta "theme-color" from HTML head as soon as possible
		// to prevent flickering of Safari color tinting while using
		// non-default theme
		const metaThemeColorElement = document.querySelector('meta[name="theme-color"]');
		if (metaThemeColorElement) {
			metaThemeColorElement.setAttribute('content', '');
		}

		this.updateThemeTinting();
	},

	// }}}
	
	userHasPermission(permission) {
		const user = this.session && this.session.user;
		if (!user) {
			return false;
		}
		if (user.role && user.role.is_admin) {
			return true;
		}
		return (user.permissions || []).includes(permission);
	}
});

// Public screens:

// {{{ Pubweb.PublicScreen

GW.define('Pubweb.PublicScreen', 'GW.Component', {
	title: APP_NAME,
	subtitle: '',

	initComponent() {
		this.el = document.gwCreateElement({
			className: 'public-screen',
			children: [{
				ref: 'headerEl',
				className: 'header',
				children: [{
					ref: 'logoEl',
					className: 'logo',
					children: [Utils.useIcon('logo', {cls: 'logo'})]
				}, {
					':skip': !this.subtitle,
					nodeName: 'h2',
					textContent: this.subtitle,
				}],
			}, {
				ref: 'bodyEl',
				className: 'body',
			}, {
				ref: 'footerEl',
				className: 'footer',
			}],
		}, this);
	},
});

// }}}
// {{{ Pubweb.MessageScreen

GW.define('Pubweb.MessageScreen', 'Pubweb.PublicScreen', {
	title: '',
	message: '',
	buttonText: '',
	kind: 'info',

	'after:initComponent'() {
		this.bodyEl.gwReplaceChildren([...this.getMessages(), {
			className: 'form-buttons',
			children: this.getButtons(),
		}]);
	},

	getMessages() {
		return [{
			':skip': !this.title,
			nodeName: 'h2',
			textContent: this.title,
		}, {
			nodeName: 'p',
			className: this.kind,
			textContent: this.message,
		}];
	},

	getButtons() {
		return [{
			nodeName: 'button',
			className: 'primary',
			textContent: this.buttonText,
			'on:click': ev => this.onButtonClick(),
		}];
	},

	onButtonClick() {
	},
});

// }}}
// {{{ Pubweb.FormScreen

GW.define('Pubweb.FormScreen', 'Pubweb.PublicScreen', {
	submitText: _('Potvrdit'),

	'after:initComponent'() {
		let links = this.getFormLinks();

		this.bodyEl.gwCreateChild({
			nodeName: 'form',
			noValidate: true,
			'on:submit': ev => {
				ev.preventDefault();
				this.onSubmit();
			},
			className: 'form',
			children: [...this.getFormFields(), {
				className: 'form-message',
				ref: 'formMessage'
			}, {
				className: 'form-buttons',
				children: this.getFormButtons(),
			}, {
				className: 'form-links' + (links.length == 0 ? ' hidden' : ''),
				children: links,
			}],
		}, this);

		setTimeout(() => this.focus(), 0);
	},

	getFormFields() {
		return [];
	},

	getFormButtons() {
		return [{
			nodeName: 'button',
			className: 'primary',
			textContent: this.submitText,
		}];
	},

	getFormLinks() {
		return [];
	},

	focus() {
		for (let f of this.el.querySelectorAll('input,select,textarea')) {
			if (!f.disabled) {
				f.focus();
				break;
			}
		}
	},

	showError(text) {
		this.formMessage.gwReplaceChildren([Utils.useIcon('alertcirclefull'), text]);
	},

	hideError() {
		this.formMessage.textContent = '';
	},

	async onSubmit() {
		this.hideError();

		if (!this.validateForm()) {
			this.showError(_('Prosíme vyplňte formulář správně.'));
			return;
		}

		let data = this.getFormFieldsData();
		let restore = this.setFormDisabled();

		try {
			await this.onSave(data);
		} catch(ex) {
			this.showError(ex.message);
		} finally {
			restore();
		}
	},

	async onSave(data) {
	},

	...FormMixin,
});

// }}}
// {{{ Pubweb.LoginScreen

GW.define('Pubweb.LoginScreen', 'Pubweb.FormScreen', {
	subtitle: `${_('Přihlášení')} - ${APP_NAME}`,

	'after:initComponent'() {
		this.submitBtnEl.textContent = _('Pokračovat');
	},

	getFormLinks() {
		return [{
			className: 'forgotten-password',
			nodeName: 'a',
			textContent: _('Zapoměli jste heslo?'),
			href: '#',
			'on:click': (e) => {
				e.preventDefault();
				this.showForgotPasswordDialog();
			},
		}];
	},

	getFormFields() {
		return [{
			ref: 'emailEl',
			xtype: 'TextField',
			name: 'email',
			type: 'email',
			label: _('E-mail'),
			autocomplete: 'username'
		}];
	},

	getFormButtons() {
		return [{
			ref: 'submitBtnEl',
			nodeName: 'button',
			className: 'primary',
			textContent: _('Přihlásit'),
		}];
	},

	redirectAfterLogin(ref) {
		if (ref) {
			if (ref.match(/^\/*api\//)) {
				ref = APP_BASE;
			}
		} else {
			ref = APP_BASE;
		}

		Application.replaceRoute(ref);
	},

	async onSave(data) {
		if (!data.password) {
			// first check if the user needs password reset
			const check = await REST.POST('session/check', {email: data.email});
			
			if (check.password_reset_email_sent) {
				this.showResetLinkSent();
			} else {
				this.emailEl.el.after(document.gwCreateElement({
					xtype: 'PasswordTextField',
					name: 'password',
					enforcePasswordRules: false,
					label: _('Nyní zadejte Heslo'),
					autocomplete: 'current-password',
				}));
				this.submitBtnEl.textContent = _('Přihlásit');
			}
			return;
		}
		// password entered -> standard login

		let params = new URLSearchParams(location.search);
		let ref = params.get('redirect');

		await Application.login(data.email, data.password);
		this.redirectAfterLogin(ref);

	},
	
	showResetLinkSent() {
		Application.show({
			xtype: 'Pubweb.MessageScreen',
			title: _('Na e-mail byl odeslán odkaz pro nastavení hesla'),
			message: _('Zkontrolujte si poštu (včetně spamu) a nastavte si nové heslo pomocí odkazu ve zprávě, kterou jsme Vám zaslali.'),
			buttonText: _('Rozumím'),
			onButtonClick() {
				Application.pushRoute(APP_BASE);
			},
		});
	},

	showForgotPasswordDialog() {
		const me = this;

		new Main.FormDialog({
			title: _('Obnovení hesla'),
			subtitle: _('Zadejte e-mail, na který Vám zašleme odkaz pro nastavení nového hesla.'),

			renderFormFields() {
				return [{
					xtype: 'TextField',
					name: 'email',
					type: 'email',
					label: _('E-mail'),
					autocomplete: 'username',
					required: true,
				}];
			},

			async onSave(data) {
				await REST.POST('session/forgotten-password', {
					email: data.email,
				});

				this.close();
				me.showResetLinkSent();
			},
		});
	},
});

// }}}
// {{{ Pubweb.ResetPasswordFinish

GW.define('Pubweb.ResetPasswordFinish', 'Pubweb.FormScreen', {
	submitText: _('Nastavit nové heslo'),

	getFormFields() {
		return [{
			nodeName: 'h2',
			textContent: _('Nové heslo'),
		}, {
			ref: 'msgEl',
			nodeName: 'p',
		}, {
			xtype: 'PasswordTextField',
			name: 'password',
			label: _('Nové heslo'),
		}];
	},

	getFormLinks() {
		return [];
	},

	getFormButtons() {
		return [{
			ref: 'submitBtnEl',
			nodeName: 'button',
			className: 'primary',
			textContent: _('Nastavit heslo a přihlásit se'),
		}];
	},

	async onSave(data) {
		await REST.POST('password-reset/' + this.token + '/perform', {
			password: data.password,
		});
		await Application.login(this.status.email, data.password);
		Application.replaceRoute(APP_BASE);
	},

	async activate() {
		setTimeout(() => {
			this.setFormFieldsData({password: ''});
		}, 100);

		let restore = this.setFormDisabled();

		try {
			let status = await REST.GET('password-reset/' + this.token);
			this.status = status;
			if (status.status === 'expired') {
				this.msgEl.textContent = _('Reset hesla již nelze provést. Platnost odkazu vypršela.');
			} else if (status.status === 'used') {
				this.msgEl.textContent = _('Reset hesla již nelze provést. Odkaz už byl použit.');
			} else if (status.status === 'okay') {
				this.msgEl.textContent = _('Zadejte nové heslo pro váš účet: {email}.')
					.replace('{email}', status.email + ' (' + status.name + ')');
				restore();
			} else {
				this.msgEl.textContent = _('Neznámá chyba.');
			}
		} catch (ex) {
			this.msgEl.textContent = ex.message;
		}
	},
});

// }}}
// {{{ Pubweb.Routes

Application.addRoutes([{
	group: 'public',
	path: APP_BASE + 'login',
	async handler({params}) {
		Application.show({
			id: 'admin.login',
			xtype: 'Pubweb.LoginScreen',
		});
	}    
}]);

// }}}

// Main app:


// {{{ Main.PasswordChangeScreen

GW.define('Main.ChangePasswordDialog', 'Main.FormDialog', {
	title: _('Změna heslo'),

	renderFormFields() {
		let me = this;

		return [{
			xtype: 'PasswordTextField',
			name: 'password',
			label: _('Nové heslo'),
		}, {
			xtype: 'PasswordTextField',
			name: 'repeat_password',
			label: _('Potvrdit heslo'),
			'wrap:getViolation'(fn) {
				let err = fn();
				if (err) {
					return err;
				}

				let data = me.getFormFieldsData();
				if (data.password != this.getValue()) {
					return _('Hesla se neshodují');
				}

				return err;
			},
		}];
	},

	async onSave(data) {
		await REST.PUT('users/self', data);
	},
})
// }}}


// // {{{ Main.ModulesSelector

GW.define('Main.ModulesSelector', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'module-chooser',
			'on*:click': ev => {
				if (ev.target.closest('a')) {
					PopupManager.hideAll();
				}
			},
		});
		this.getAppModules().then(modules => {
			this.el.gwReplaceChildren(modules.map(m => this.renderCategory(m)));
		})
	},

	async getAppModules() {
		return [{
			title: _('Domů'),
			items: [{ title: _('Rozcestník'), icon: 'home', href: '/'} ]
		}, ...((await Main.Menu.getMenuItems()).map(menu => ({
			...menu,
			items: menu.items.filter(item => Application.userHasPermission(item.permission)),
		})).filter(menu => menu.items.length))];
	},

	renderCategory(menu_item) {
		return {
			className: 'main-modules-section',
			children:[{
				nodeName: 'h1',
				className: 'h5',
				textContent: menu_item.title
			}, {
				className: 'module-chooser',
				children: menu_item.items.map(item => this.renderModule(item)),
			}]
		};
	},

	renderModule(m) {
		return {
			className: 'module',
			nodeName: 'a',
			href: m.href,
			target: m.href_target,
			children: [{
				className: 'logo',
				children: [Utils.useIcon(m.icon || 'phone')],
			}, {
				className: 'info',
				children: [{
					className: 'title',
					textContent: m.title,
				}, {
					className: 'tagline',
					textContent: m.tagline,
				}],
			}],
		};
	},
});

// }}}
// {{{ Main.Screen

GW.define('Main.Screen', 'GW.Component', {
	initComponent() {
		let user = Application.session && Application.session.user;

		this.el = document.gwCreateElement({
			className: 'main-screen js-msgbus',
			children: [{
				ref: 'headerEl',
				className: 'header',
				children: [{
					className: 'modules',
					ref: 'modulesEl',
					children: [Utils.useIcon('apps')],
					'on:click': ev => this.showModulesPopup(ev),
				}, {
					className: 'logo',
					ref: 'logoEl',
					children: [Utils.useIcon('logo')],
					'on:click': ev => { 
						Application.pushRoute(APP_BASE + 'dashboard');
					}
				}, {
					className: 'title',
					ref: 'titleEl',
					children: [(this.titleIcon ? Utils.useIcon(this.titleIcon) : undefined), this.title],
				}, {
					className: 'app-title',
					textContent: APP_NAME,
				}, {
					ref: 'userProfileEl',
					className: 'profile',
					children: [{
						className: 'icon',
					}, {
						className: 'name',
						ref: 'userNameEl',
					}],
					'on:click': ev => this.showProfilePopup(ev),
				}],
			}, {
				ref: 'bodyEl',
				className: 'body page-centered-container',
			}, {
				ref: 'sidebarEl',
				className: 'sidebar hidden',
			}, {
				ref: 'footerEl',
				className: 'footer hidden',
			}],
		}, this);

		this.userProfileEl.title = user ? `${user.name}\n(${user.email})` : '';
		this.userNameEl.textContent = user ? user.name : '';
		this.userProfileEl.gwHide(!user);

		this.updateSidebarMenu();
		this.updateAppStatus();
	},

	updateAppStatus() {
		if (Application.serverVersion != env.VERSION) {
			this.appStatus.classList.remove('hidden');
			this.appStatusBtn.title =
				_('Aplikace byla aktualizována na verzi {version}, je třeba obnovit stránku pro dokončení aktualizace.')
					.replace('{version}', Application.serverVersion);
		}
	},

	showModulesPopup(ev) {
		let modsEl = ev.target.closest('.modules');
		let popup = new Main.ModulesSelector();

		PopupManager.show(popup, {
			fixed: true,
			top: this.headerEl.offsetHeight,
			left: 0,
			toggleEl: modsEl,
		});
	},

	getSidebarMenu() {
		return [];
	},

	//XXX: call on activate() to update selected item
	updateSidebarMenu() {
		let menu = this.getSidebarMenu();
		if (menu.length == 0) {
			return;
		}

		this.sidebarEl.gwCreateChild({
			className: 'vertical-menu',
			children: menu,
		});

		this.sidebarEl.classList.remove('hidden');

		for (let a of this.sidebarEl.querySelectorAll('a')) {
			let match = Application.routePath.startsWith(a.getAttribute('href') + '/')
				|| Application.routePath == a.getAttribute('href');

			a.classList.toggle('active', match);
		}
	},

	getProfileOptions() {
		function setTheme(theme) {
			Application.setDocumentTheme(theme);
			PopupManager.hideAll();
		}

		return [{
			':skip': !Application.session?.user,
			iconName: 'user',
			text: Application.session?.user.name,
			cls: 'name'
		}, {
			render: {
				className: 'option separator',
			}
		}, {
			hidden: Application.session.user.external,
			iconName: 'pencil',
			text: _('Změnit kontaktní údaje'),
			handle: c => this.showUserInfoChangeDialog(),
		}, {
			hidden: Application.session.user.external,
			iconName: 'lock',
			iconHover: 'unlock',
			text: _('Změnit heslo'),
			handle: c => this.showPasswordChangeDialog(),
		// }, {
		// 	iconName: 'globe',
		// 	text: _('Jazyk'),
		// 	submenu: i18n.LANGUAGES.map(l => {
		// 		return {
		// 			rightIconName: l.id == i18n.lang ? 'check' : null,
		// 			cls: l.id == i18n.lang ? 'active' : undefined,
		// 			text: l.name,
		// 			handle: () => Application.setLanguage(l.id),
		// 		};
		// 	}),
		}, {
			iconName: 'moon',
			text: _('Vzhled'),
			submenu: [{
				rightIconName: !Application.getDocumentTheme() ? 'check' : null,
				cls: !Application.getDocumentTheme() ? 'active' : undefined,
				iconName: 'sunmoon',
				text: _('Automatický'),
				handle: () => setTheme(),
			}, {
				rightIconName: Application.getDocumentTheme() == 'light' ? 'check' : null,
				cls: Application.getDocumentTheme() == 'light' ? 'active' : undefined,
				iconName: 'sun',
				text: _('Světlý motiv'),
				handle: () => setTheme('light'),
			}, {
				rightIconName: Application.getDocumentTheme() == 'dark' ? 'check' : null,
				cls: Application.getDocumentTheme() == 'dark' ? 'active' : undefined,
				iconName: 'moon',
				text: _('Tmavý motiv'),
				handle: () => setTheme('dark'),
			}],
		// }, {
		// 	render: {
		// 		className: 'option separator',
		// 	},
		// }, {
		// 	hidden: !env.BUGREPORTS,
		// 	iconName: 'bug',
		// 	text: _('Nahlásit problém'),
		// 	handle: e => {
		// 		this.reportIssue();
		// 	},
		// }, {
		// 	iconName: 'bookopen',
		// 	text: _('Dokumentace'),
		// 	handle: e => {
		// 		window.open(APP_BASE + 'docs', '_blank');
		// 	},
		// }, {
		// 	iconName: 'informationcircle',
		// 	text: _('O aplikaci'),
		// 	handle: c => this.showAboutDialog(),
		// }, {
		}, {
			render: {
				className: 'option separator',
			},
		}, {
			iconName: 'logout',
			text: _('Odhlásit'),
			handle: async c => {
				await Application.logout();
			},
		}];
	},

	showProfilePopup(ev) {
		let popup = new PopupMenu({
			options: this.getProfileOptions(),

			'after:initComponent'() {
				this.el.classList.add('profile-popup');
			},
		});

		PopupManager.show(popup, {
			anchorEl: ev.target.closest('.profile'),
			forceAxis: 'vertical',
			preferReadingOrder: true,
		});
	},

	async showAboutDialog() {
		let ver = await REST.GET('version');

		new Main.Dialog({
			title: _('O aplikaci'),

			'after:initComponent'() {
				this.bodyEl.classList.add('main-about-dialog');
				this.bodyEl.gwReplaceChildren([{
					nodeName: 'h4',
					textContent: APP_NAME,
				}, {
					nodeName: 'p',
					textContent: _('BusinessCom a.s.'),
				}, {
					nodeName: 'p',
					children: [{
						nodeName: 'a',
						href: 'https://www.businesscom.cz',
						target: '_blank',
						textContent: _('www.businesscom.cz'),
					}]
				}, {
					nodeName: 'p',
					textContent: _('Dobrušská 1794/1\n147 00 Praha 4'),
				}, {
					nodeName: 'p',
					children: [{
						nodeName: 'a',
						href: 'tel:+420261303303',
						textContent: _('+420 261 303 303'),
					}, {
						nodeName: 'br',
					}, {
						nodeName: 'a',
						href: 'mailto:info@businesscom.cz',
						textContent: _('info@businesscom.cz'),
					}]
				}, {
					nodeName: 'p',
					textContent: _('Verze aplikace') + ': ' + ver.be,
				}]);
			},
		});
	},

	async showUserInfoChangeDialog() {
		new Main.FormDialog({
			title: _('Změna kontaktních údajů'),
			renderFormFields() {
				return [{
					xtype: 'TextField',
					name: 'name',
					label: _('Jméno'),
					value: Application.session.user.name,
				}, {
					xtype: 'TextField',
					name: 'phone',
					label: _('Telefon'),
					value: Application.session.user.phone,
					optional: true,
				}];
			},
			async onSave(data) {
				await REST.PUT('users/self', data);
				if (data.name !== Application.session.user.name || data.phone !== Application.session.user.phone) {
					location.reload(); // quick'n'dirty way to reload changed values in session
				}
			},
		});
	},

	async showPasswordChangeDialog() {
		new Main.ChangePasswordDialog();
	},

	updateServerStatus() {
		let ok = Application.socket.isReady();

		this.serverStatus.gwReplaceChildren(ok ? [Utils.useIcon('dot')] : [Utils.useIcon('dot'), {
			className: 'text',
			textContent: _('Server odpojen'),
		}]);

		this.serverStatus.dataset.status = ok ? 'ok' : 'fail';
	},
});

// }}}

// {{{ MultiStep.Screen

GW.define('MultiStep.Screen', 'Main.Screen', {
	currentStep: 0,

	hideNavButtons: false,

	async 'after:initComponent'() {
		this.steps = await this.getSteps();

		this.bodyEl.gwCreateChild({
			className: 'page-wrapper',
			children: [{
				ref: 'stepper',
				xtype: 'Widgets.Stepper',
				getSteps: () => this.steps.map(step => ({
					label: step.name,
					'on:click': () => this.previousStep(),
				})),
			}, {
				ref: 'cards',
				xtype: 'Widgets.CardSwitcher',
				'on:gonext': () => this.nextStep(),
				'on:goback': () => this.previousStep(),
			}, {
				nodeName: 'br',
			}, {
				':skip': this.hideButtons,
				ref: 'navButtons',
				className: 'form-buttons fixed',
				children: [{
					nodeName: 'button',
					type: 'button',
					className: 'button secondary icon-left',
					children: [Utils.useIcon('arrow-simple-left'), _('Zpět')],
					'on:click': (ev) => {
						ev.preventDefault();
						this.previousStep();
					},
				}, {
					className: 'button-group ml-auto',
					children: [{
						ref: 'stepButtons',
						className: 'step-buttons',
					}, {
						nodeName: 'button',
						type: 'button',
						className: 'button primary icon-right',
						children: [{
							ref: 'nextStepText',
						}, Utils.useIcon('arrow-simple-right')],
						'on:click': (ev) => {
							ev.preventDefault();
							this.nextStep();
						},
					}]
				}]
			}],
		}, this);

		
		this.showStep(this.currentStep);
	},

	getSteps() {
		return [];
	},

	updateNavButtons(step, c) {
		if (this.navButtons) {
			if (step.nextStepText) {
				this.nextStepText.textContent = step.nextStepText;
			} else {
				this.nextStepText.textContent = _('Pokračovat');
			}
			this.stepButtons.gwReplaceChildren(step.renderStepButtons ? step.renderStepButtons(c) : []);
		}
	},

	async showStep(idx) {
		let step = this.steps[idx];
		let c = await this.cards.show(step.component);

		this.updateNavButtons(step, c);

		this.activeStepComponent = c;
		this.stepper.setStep(idx + 1);

		this.currentStep = idx;

		this.bodyEl.scrollTo({ top: 0, left: 0, behavior: "smooth" });
	},

	async nextStep() {
		const step = this.steps[this.currentStep];

		if (step.onNext) {
			if (await step.onNext(this.activeStepComponent)) {
				return;
			}
		}

		await this.showStep(++this.currentStep);
	},

	async previousStep() {
		const step = this.steps[this.currentStep];

		if (step.onBack) {
			if (await step.onBack(this.activeStepComponent)) {
				return;
			}
		}

		await this.showStep(--this.currentStep);

	}
});

// }}}
// {{{
GW.define('Main.Menu', 'GW.Object', {
	singleton: true,
	
	// cached menu items
	menu_items: null,
	
	async getMenuItems() {
		return this.menu_items || this.loadMenuItems();
	},
	
	invalidate() {
		this.menu_items = null;
	},
	
	async loadMenuItems() {
		const folders = await REST.GET('documents/folders');
		return this.menu_items = [{
			title: _("Nabídky"),
			items: [...env.PRODUCTS.map(product => ({
				permission: 'offers.create.' + product.id,
				title: product.name,
				icon: 'plus',
				href: APP_BASE + 'offers/create?product=' + encodeURIComponent(product.id),
			})), {
				permission:'offers.list',
				title: _('Seznam nabídek'),
				icon: 'list',
				href: APP_BASE + 'offers',
			}],
		}, {
			title: "Dokumenty",
			items: [{
				title: _('Stránky produktu bc4.cz'),
				icon: 'documentwithcontent',
				href: 'https://bc4.cz',
				target: '_blank',
			}, ...folders.map(folder => ({
				permission: `documents.folder.${folder.id}`,
				title: folder.name,
				icon: 'documentwithcontent',
				href: APP_BASE + 'documents/' + folder.id,
			}))],
		}, {
			title: "Ústředny",
			items: [{
				permission: 'pbxs.create',
				title: _('Vytvořit ústřednu'),
				icon: 'plus',
				href: APP_BASE + 'pbxs/create',
			}, {
				permission: 'pbxs.list',
				title: _('Seznam ústředen'),
				icon: 'list',
				href: APP_BASE + 'pbxs',
			}],
		}, {
			title: "Administrace",
			items: [{
				permission: 'prices.edit',
				title: _('Změna jednotkových cen'),
				icon: 'list',
				href: APP_BASE + 'prices',
			}, {
				permission: 'users.admin',
				title: _('Správa uživatelů, rolí a oprávnění'),
				icon: 'user',
				href: APP_BASE + 'users',
			}, {
				permission: 'documents.admin',
				title: _('Správa dokumentů'),
				icon: 'documentwithcontent',
				href: APP_BASE + 'documents',
			}],
		}];
	},
	
});
Application.logoutActions.push(() => Main.Menu.invalidate());

// }}}

// {{{ Main.ModulesScreen

GW.define('Main.ModulesScreen', 'Main.Screen', {

	async 'after:initComponent'() {

		const visible_menu = (await Main.Menu.getMenuItems()).map(menu => ({
			...menu,
			items: menu.items.filter(item => Application.userHasPermission(item.permission)),
		})).filter(menu => menu.items.length);
		
		if (visible_menu.length) {
			this.bodyEl.gwCreateChild({
				className: 'main-modules',
				children: visible_menu.map(menu_item => this.renderCategory(menu_item))
			});
		} else {
			this.bodyEl.gwCreateChild({
				nodeName: 'p',
				textContent: _('Nemáte oprávnění k přístupu do aplikace'),
			});
		}
	},

	renderCategory(menu_item) {
		return {
			className: 'main-modules-section',
			children:[{
				nodeName: 'h1',
				className: 'h2 main-title',
				textContent: menu_item.title
			}, {
				className: 'module-chooser',
				children: menu_item.items.map(item => this.renderModule(item)),
			}]
		};
	},

	renderModule(m) {
		return {
			className: 'module ' + (m.href ? '' : 'disabled'),
			nodeName: 'a',
			href: m.href,
			target: m.target || null,
			children: [{
				className: 'logo',
				children: [Utils.useIcon(m.icon || 'phone')],
			}, {
				className: 'info',
				children: [{
					className: 'title',
					textContent: m.title,
				}, {
					className: 'tagline',
					textContent: m.tagline,
				}],
			}],
		};
	},
});

// }}}

// {{{ OfferListing.Screen

GW.define('OfferListing.Screen', 'Main.Screen', {
	async getOffers() {

		let params = new URLSearchParams(location.search);
		const q = params.get('q');

		if (q && !this.searchEl.value) {
			this.searchEl.value = GW.htmlEncode(q);
		}

		let offers = [];
		try {
			offers = await REST.GET( 'offers' + (q ? '?q=' + encodeURIComponent(q) : '') );
		} catch (e) {
			console.error(e);
		}
		this.listingTable.setData(offers);

		if(offers.length >= 2000) {
			this.searchStatus.textContent = _('Byl dosažen limit vyhledávání.\nProsím, zužte výběr zadáním vyhledávacích kritérií.') + ' 👉' ;
		}
	},

	'after:initComponent'() {
		this.titleEl.textContent = _('Nabídky');
		this.bodyEl.gwCreateChild({
			className: 'page-wrapper',
			children: [{
				className: 'page-heading',
				children: [{
					nodeName: 'h1',
					className: 'h2 main-title',
					textContent: _('Přehled nabídek'),
				}, {
					ref: 'searchStatus',
					nodeName: 'span',
					className: 'text-error text-center text-pre',
				}, {
					ref: 'searchEl',
					nodeName: 'input',
					autofocus: true,
					type: 'search',
					placeholder: _('Hledat dle ID, roku, firmy, adresy, IČ, obchodníka, telefonu, emailu'),
					className: 'small',
					style: {"width": "420px", "max-width": "100%", "background-color": "var(--panel-bg)"},
					'on:input': ev => {
						Utils.dedupeCalls(this, 'setQuery', 300, () => {
							Application.route({
								paramsFn: params => {
									params.set('q', ev.target.value);
									return params;
								},
							});
							this.getOffers();
						});
					},
				}]
			}, {
				xtype: 'FilterableSmartTable',
				extraClass: 'table-alternative',
				ref: 'listingTable',
				emptyText: _('Žádná odpovídající nabídka nebyla nalezena'),
				renderRow(tr, row) {
					if (row.inactive_reason) {
						tr.classList.add('offer-inactive');
					}
				},
				getColumns() {
					return [{
						id: "created",
						name: _("Datum nabídky"),
						format: 'date',
						filter: {
							type: 'options',
							showSearch: true,
						},
						sortable: true,
					}, {
						id: "id",
						name: _("ID nabídky"),
						filter: {
							type: 'options',
							showSearch: true,
						},
						sortable: true,
					}, {
						id: "product",
						name: _("Produkt"),
						formatCell(td, v, row) {
							td.textContent = env.PRODUCTS.filter(p => p.id == v).map(p => p.name)[0] || v;
						},
						filter: {
							type: 'options',
							showSearch: true,
						},
						sortable: true,
					}, {
						id: "company_name",
						name: _("Firma"),
						filter: {
							type: 'options',
							showSearch: true,
						},
						sortable: true,
					}, {
						id: "company_reg_number",
						name: _("IČ"),
						filter: {
							type: 'options',
							showSearch: true,
						},
						sortable: {
							type: 'numeric',
						},
					}, {
						id: "sales_rep_name",
						name: _("Obchodník"),
						filter: {
							type: 'options',
							showSearch: true,
						},
						sortable: true,
					}, {
						id: "language",
						name: _("Jazyk"),
						filter: {
							type: 'options',
							showSearch: true,
						},
						sortable: true,
						formatCell(td, v, row) {
							td.textContent = {
								cs: _('Česky'),
								en: _('Anglicky')
							}[row.language]
						}
					}, {
						id: "inactive_reason",
						name: _("Stav"),
						formatCell(td, v, row) {
							if (row.inactive_reason === 'expired') {
								td.gwCreateChild({
									nodeName: 'span',
									className: 'offer-inactive-badge',
									textContent: _('Nabídka po splatnosti'),
								});
							} else if (row.inactive_reason === 'derived') {
								td.gwCreateChild({
									nodeName: 'a',
									className: 'offer-inactive-badge offer-inactive-badge-link',
									href: APP_BASE + 'offers/' + row.derived_offer_id,
									textContent: _('Byla vytvořena novější nabídka'),
									'on:click': (e) => {
										e.preventDefault();
										Application.pushRoute(APP_BASE + 'offers/' + row.derived_offer_id);
									},
								});
							}
						},
					}, {
						id: "ctl",
						name: "",
						formatCell(td, v, row) {
							const copyGroup = td.gwCreateChild({ className: 'button-group' });
							const viewGroup = td.gwCreateChild({ className: 'button-group' });

							const otherProducts = env.PRODUCTS.filter(p => p.id !== row.product && Application.userHasPermission('offers.create.' + p.id));
							if (otherProducts.length > 0) {
								copyGroup.gwCreateChild({
									nodeName: 'button',
									type: 'button',
									className: 'button secondary small icon-only',
									'on:click': (e) => {
										e.preventDefault();
										const popup = new PopupMenu({
											options: otherProducts.map(p => ({
												text: p.name,
												handle: () => {
													Application.pushRoute(APP_BASE + 'offers/create?product=' + encodeURIComponent(p.id) + '&offerId=' + encodeURIComponent(row.id));
												},
											})),
										});
										PopupManager.show(popup, {
											anchorEl: e.currentTarget,
											forceAxis: 'vertical',
											preferReadingOrder: true,
										});
									},
									title: 'Zkopírovat nabídku pro jiný produkt',
									children: [Utils.useIcon('fi-corner-left-up')],
								});
							}
							if (Application.userHasPermission('offers.create.' + row.product)) {
								copyGroup.gwCreateChild({
									nodeName: 'button',
									type: 'button',
									className: 'button secondary small icon-only',
									'on:click': (e) => {
										e.preventDefault();
										Application.pushRoute(APP_BASE + 'offers/create?product=' + encodeURIComponent(row.product) + '&offerId=' + encodeURIComponent(row.id));
									},
									title: 'Nová předvyplněná nabídka',
									children: [Utils.useIcon('duplicate')],
								});
							}
							if (Application.userHasPermission('offers.view_budget')) {
								viewGroup.gwCreateChild({
									nodeName: 'a',
									className: 'button secondary small icon-only',
									href: APP_BASE + 'budget/' + row.id,
									'on:click': (e) => {
										e.preventDefault();
										Application.pushRoute(APP_BASE + 'budget/' + row.id);
									},
									title: 'Zobrazit rozpočetku',
									children: [Utils.useIcon('chart')],
								});
							}
							if (Application.userHasPermission('offers.view_offer')) {
								viewGroup.gwCreateChild({
									nodeName: 'a',
									className: 'button secondary small icon-only',
									href: APP_BASE + 'offers/' + row.id,
									'on:click': (e) => {
										e.preventDefault();
										Application.pushRoute(APP_BASE + 'offers/' + row.id);
									},
									title: 'Zobrazit nabídku',
									children: [Utils.useIcon('eye')],
								});
							}
						},

					}];
				},
			}],
		}, this);

		this.getOffers();
	},
});

// }}}

// {{{ NewOffer.Screen

GW.define('NewOffer.Screen', 'MultiStep.Screen', {
	title: _('Nová nabídka'),
	hideButtons: false,
	
	product: null, // id of the seller product
	
	offerId: null, // if of copied offer (null for new offer)
	offerFormDataPromise: null, // existing offer form data when copying an offer
	
	formData: {}, // cached data from the offer form, to be saved to DB when new offer is confirmed
	language: 'cs',

	'before:initComponent'() {
		// reset formData, set instance variable, overwrite the prototype
		this.formData = {};

		if (this.offerId) {
			// intentionally no await, store promise, to be able to await it
			this.offerFormDataPromise = REST.GET('offers/' + this.offerId + '/form_data')
				.then(r => {
					this.language = r.language;
					this.formData = r.form_data;
				});
		}
	},

	getLanguageSwitchButton(component, language) {
		const buttonText = (lang) => lang === 'cs' ? _('Anglicky') : _('Česky');

		return {
			nodeName: 'button',
			type: 'button',
			className: 'button primary',
			textContent: buttonText(language),
			'on:click': async (ev) => {
				const switchToLang = ev.target.textContent === 'Česky' ? 'cs' : 'en'
				ev.target.textContent = buttonText(switchToLang);
				await component.changeLanguage(switchToLang);
			}
		}
	},

	getSteps() {
		const me = this;

		const getFormData = async () => {
			// make sure it is loaded
			await this.offerFormDataPromise;
			return this.formData;
		}
		
		const setToFormData = async data => {
			// make sure it is loaded
			await this.offerFormDataPromise;
			Object.assign(this.formData, data);
		}
		
		return [{
			name: _('Kalkulace'),
			component: {
				id: 'formStep',
				xtype: 'NewOfferForm.' + this.product,
				product: this.product,
				getFormData,
			},
			onBack: () => {
				if (history.length > 1) {
					history.back();
				} else {
					Application.pushRoute(APP_BASE + 'offers');
				}

				return true;
			},
			onNext: async (c) => {
				const formData = await c.getOfferFormData();
				if (!formData) {
					return true;
				}
				await setToFormData(formData);
			},
		}, {
			name: _('Hardware'),
			component: {
				offerProductId: this.product,
				xtype: 'HardwarePricesForm',
				getFormData,
			},
			onBack: async (c) => {
				const formDataHardware = c.getFormFieldsData();
				if (formDataHardware) {
					await setToFormData(formDataHardware);
				}
			},
			onNext: async (c) => {
				const formDataHardware = c.getFormFieldsData();
				if (!formDataHardware) {
					return true;
				}

				await setToFormData(formDataHardware);

				if (Application.userHasPermission('offers.view_budget')) {
					this.budgetData = await REST.POST('offers/calculate/budget-data', {
						form_data: this.formData,
						product: this.product,
					});
				}
				if (Application.userHasPermission('offers.view_offer')) {
					this.offerData = await REST.POST('offers/calculate/offer-data', {
						form_data: this.formData,
						product: this.product,
					});
				}
			},
		}, ...[{
			visible: Application.userHasPermission('offers.view_budget'),
			name: _('Rozpočetka'),
			component: {
				xtype: 'BudgetTable',
				getData: () => this.budgetData,
				getLanguage: () => this.language
			},
			renderStepButtons(budgetTable) {
				return [me.getLanguageSwitchButton(budgetTable, me.language),{
					nodeName: 'button',
					type: 'button',
					className: 'button primary icon-right ml-auto btn-export',
					children: [_('Export do XLSX'), Utils.useIcon('file-xls')],
					'on:click': (ev) => {
						ev.preventDefault();
						Export.xlsx({
							filename: _('Nabídka') + '.xlsx',
							sheets: budgetTable.getXlsxExportData(),
						});
					}
				}, {
					nodeName: 'button',
					type: 'button',
					className: 'button primary icon-right btn-export',
					children: [_('Export do PDF'), Utils.useIcon('file-pdf')],
					'on:click': (ev) => {
						ev.preventDefault();
						window.print();
					}
				}]
			},
		}, {
			visible: Application.userHasPermission('offers.view_offer'),
			name: _('Indikativní nabídka'),
			component: {
				xtype: 'OfferDetail',
				getLanguage: () => this.language,
				getData: () => ({...this.offerData, product: this.product})
			},
			renderStepButtons(offerDetail) {
				return [me.getLanguageSwitchButton(offerDetail, me.language)];
			}
		}].filter(s => s.visible).map((step, i, arr) => {
			return i === arr.length - 1 ? { // modify the last step
				...step,
				nextStepText: _('Uložit'),
				onNext: async (offerDetail) => {
					
					// XXX: offer_data and budget_data are generated again on the server, the preview shown
					//      to the user in the previous steps are ignored. 

					const r = await REST.POST('offers', {
						form_data: this.formData,
						product: this.product,
						language: offerDetail.lang,
						...(this.offerId ? {source_offer_id: this.offerId} : {}),
					});
					if (Application.userHasPermission('offers.view_offer')) {
						Application.pushRoute(APP_BASE + 'offers/' + r.id + '?justCreated');
					} else {
						Application.pushRoute(APP_BASE + 'budget/' + r.id + '?justCreated');
					}
					return true;
				},
			} : step;
		})];
	},
});

// }}}
// {{{ NewOfferForm

GW.define('NewOfferForm', 'GW.Component', {
	product: null,
	getFormData: null, // optional async getter with form data

	formData: null, // resolved form data from getFormData

	initComponent() {
		this.el = document.gwCreateElement({
			className: 'offer-form',
			nodeName: 'form',
			noValidate: true,
			'on:submit': ev => {
				ev.preventDefault();
				this.onSubmit();
			},
			ref: 'offerForm',
		}, this);

		if (this.title) {
			document.querySelector('.main-screen > .header > .title').textContent = this.title;
		}

		this.reloadFormData();
	},

	/**
	 * Products: extension point
	 */
	async reloadFormData() {
		this.formData = this.getFormData && await this.getFormData();
		
		// getFormFields() is dependent on loaded data, need to be here and not in initComponent()
		this.offerForm.gwReplaceChildren([{
			className: 'form-fields-group',
			children: this.getFormFields(),
		}], this);

		if (this.formData) {
			this.setFormFieldsData(this.formData, false);
		}

		this.updateContactsVisibility();

		// Needed for autofocus while navigating via Application.pushRoute
		const autofocusEl = this.el.querySelector('input[autofocus]')
		if (autofocusEl) {
			setTimeout(()=>{
				autofocusEl.focus();
			}, 100)
		}
	},

	updateContactsVisibility() {
		let data = this.getFormFieldsData();

		this.companyContactsPbxAdmin.gwHide(data['company_pbx_admin_same_as_rep']);
		this.companyContactsSystemAdmin.gwHide(data['company_system_admin_same_as_rep']);
	},

	// {{{ Form fields
	getFormFields() {
		return [{
			className: 'panel-container',
			children: [{
				nodeName: 'h3',
				className: 'title',
				textContent: _('Dodavatel'),
			}, {
				nodeName: 'h5',
				className: 'title',
				textContent: _('Obchodní zástupce'),
			}, {
				className: 'grid',
				children: [{
					xtype: 'TextField',
					name: 'sales_rep_name',
					label: _('Jméno'),
					autocomplete: 'name',
					value: this.formData?.sales_rep_name || Application.session.user.name,
					optional: true,
					autofocus: true,
				}],
			}, {
				className: 'grid',
				children: [{
					xtype: 'TextField',
					type: 'phone',
					name: 'sales_rep_phone',
					label: _('Telefon'),
					autocomplete: 'tel',
					value: this.formData?.sales_rep_phone || Application.session.user.phone,
					optional: true,
				}, {
					xtype: 'TextField',
					type: 'email',
					name: 'sales_rep_email',
					label: _('E-mail'),
					autocomplete: 'email',
					value: this.formData?.sales_rep_email || Application.session.user.email,
					optional: true,
				}]
			}],
		}, {
			className: 'panel-container',
			children: [{
				nodeName: 'h3',
				className: 'title',
				textContent: _('Zákazník'),
			}, {
				className: 'grid grid-1-2',
				children: [{
					xtype: 'IcoField',
					name: 'company_reg_number',
					label: _('IČ'),
					resolveFunc: v => {
						const companyAddressInput = this.offerForm.querySelector('[data-name=company_address] input');
						const companyNameInput = this.offerForm.querySelector('[data-name=company_name] input')
						if ((companyAddressInput.value === v?.sidlo?.textovaAdresa && companyNameInput.value === v?.obchodniJmeno)
							|| 
							((companyAddressInput.value || companyNameInput.value) && 
								!confirm(_('Pole "Sídlo" nebo "Název firmy" jsou již vyplněna, ale nesouhlasí s daty vrácených z ARES. Pokud budete pokračovat, dojde k jejich přepsání! Chcete pokračovat?'))
							)) {
							return
						}
						companyAddressInput.value = v?.sidlo?.textovaAdresa;
						companyNameInput.value = v?.obchodniJmeno;
					},
				}, {
					xtype: 'TextField',
					name: 'company_name',
					label: _('Název firmy'),
					autocomplete: 'organization',
				}]
			}, {
				xtype: 'TextField',
				name: 'company_address',
				label: _('Sídlo'),
				autocomplete: 'street-address',
				optional: true,
			}, {
				nodeName: 'h6',
				className: 'title',
				textContent: _('Zodpovědná osoba zákazníka'),
			},{
				className: 'grid',
				children: [{
					xtype: 'TextField',
					name: 'company_rep_name',
					label: _('Jméno'),
					autocomplete: 'name',
					optional: true,
				}]
			}, {
				className: 'grid',
				children: [{
					xtype: 'TextField',
					type: 'phone',
					name: 'company_rep_phone',
					label: _('Telefon'),
					autocomplete: 'tel',
					optional: true,
				}, {
					xtype: 'TextField',
					type: 'email',
					name: 'company_rep_email',
					label: _('E-mail'),
					autocomplete: 'email',
					optional: true,
				}]
			}, {
				nodeName: 'h6',
				className: 'title',
				textContent: _('Administrátor pro SIP trunk/PBX'),
			}, {
				nodeName: 'button',
				className: 'btn secondary small',
				textContent: _('Stejný jako zodpovědná osoba zákazníka'),
				'on:click': ev => {
					ev.preventDefault();
					const data = this.getFormFieldsData();
					this.setFormFieldsData({
						company_pbx_admin_name: data.company_rep_name,
						company_pbx_admin_phone: data.company_rep_phone,
						company_pbx_admin_email: data.company_rep_email,
					}, false);
				},
			}, {
				className: 'company-contacts hidden',
				ref: 'companyContactsPbxAdmin',
				children: [{
					className: 'grid',
					children: [{
						xtype: 'TextField',
						name: 'company_pbx_admin_name',
						label: _('Jméno'),
						autocomplete: 'name',
						optional: true,
					}],
				}, {
					className: 'grid',
					children: [{
						xtype: 'TextField',
						type: 'phone',
						name: 'company_pbx_admin_phone',
						label: _('Telefon'),
						autocomplete: 'tel',
						optional: true,
					}, {
						xtype: 'TextField',
						type: 'email',
						name: 'company_pbx_admin_email',
						label: _('E-mail'),
						autocomplete: 'email',
						optional: true,
					}],
				}],
			}, {
				nodeName: 'h6',
				className: 'title',
				textContent: _('Administrátor systémových řešení (ADSR)'),
			}, {
				nodeName: 'button',
				className: 'btn secondary small',
				textContent: _('Stejný jako zodpovědná osoba zákazníka'),
				'on:click': ev => {
					ev.preventDefault();
					const data = this.getFormFieldsData();
					this.setFormFieldsData({
						company_system_admin_name: data.company_rep_name,
						company_system_admin_phone: data.company_rep_phone,
						company_system_admin_email: data.company_rep_email,
					}, false);
				},
			},{
				className: 'company-contacts hidden',
				ref: 'companyContactsSystemAdmin',
				children: [{
					className: 'grid',
					children: [{
						xtype: 'TextField',
						name: 'company_system_admin_name',
						label: _('Jméno'),
						autocomplete: 'name',
						optional: true,
					}],
				}, {
					className: 'grid',
					children: [{
						xtype: 'TextField',
						type: 'phone',
						name: 'company_system_admin_phone',
						label: _('Telefon'),
						autocomplete: 'tel',
						optional: true,
					}, {
						xtype: 'TextField',
						type: 'email',
						name: 'company_system_admin_email',
						label: _('E-mail'),
						autocomplete: 'email',
						optional: true,
					}],
				}],
			}],
		}, {
			className: 'panel-container',
			children: [{
				nodeName: 'h3',
				className: 'title',
				textContent: _('Nabídka'),
			}, ...this.getOfferFormFields()]
		}];
	},
	// }}}
	
	getOfferFormFields() {
		// this is intended to be defined in seller plugin
		throw "getOfferFormFields() not defined";
	},

	async getOfferFormData() {
		if (!this.validateForm()) {
			const firstError = this.offerForm.querySelector('.form-field.error');
			if (firstError) {
				firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
				setTimeout(() => {
					firstError.querySelector('input')?.focus();
				}, 500);
			}
			return;
		}

		return this.getFormFieldsData();
	},

	...FormMixin,

});

GW.define('HardwarePricesForm', 'GW.Component', {

	product: null,
	offerProductId: null,
	getFormData: null, // optional async getter with form data

	initComponent() {
		this.el = document.gwCreateElement({
			className: 'offer-form',
			nodeName: 'form',
			noValidate: true,
			'on:submit': ev => {
				ev.preventDefault();
				this.onSubmit();
			},
			ref: 'offerForm',
			children: [{
				className: 'form-fields-group',
				children: [{
					className: 'panel-container',
					children: [{
						nodeName: 'h3',
						className: 'title',
						textContent: _('Hardware'),
					}, {
						ref: 'hardwareItemsEl',
					}],
				}],
			}],
		}, this);
		this.reloadFormData();
		this.updateHardwareItems();
	},

	async reloadFormData() {
		const formData = this.getFormData && await this.getFormData();

		if (formData) {
			this.setFormFieldsData(formData, false);
		}
	},

	async updateHardwareItems() {
		const {items} = await REST.GET(`offers/hardware?offerProductId=${this.offerProductId}`);
		this.hardwareItemsEl.gwReplaceChildren(items.map(item => ({
			className: 'grid',
			children: [{
				xtype: 'SpinnerField',
				type: 'number',
				min: 0,
				step: 1,
				name: 'hw__' + item.product_id,
				label: item.name,
				labelLink: item?.product_url,
				labelLinkTitle: _('Otevřít stránku produktu'),
				tooltip: [
					{textContent: item.description},
					{nodeName: 'img', src: item.image_url}
				],
				autocomplete: 'off',
				value: 0,
			}, {
				textContent: '',
			}]
		})));
		this.reloadFormData(); // update the values from the (loaded) formData
	},
	
	...FormMixin,
	
});

// }}}


GW.define('NewOfferForm.LicencesTable', 'Main.Dialog', {
	'after:initComponent'() {
		this.bodyEl.classList.add('main-about-dialog');
		this.bodyEl.gwReplaceChildren([{
			xtype: 'SmartTable',
			extraClass: 'table-accented primary',
			ref: 'licencesTable',
			getColumns() {
				return [{
					id: "f",
					name: _("Funkce"),
					align: 'text-pre',
				}, {
					id: "s",
					name: _("Standard\nphone"),
					align: 'text-center text-pre',
					formatCell(td, v, row) {
						if (v) {
							td.gwCreateChild(Utils.useIcon('check'));
							td.classList.add('text-primary');
						}
					},
				}, {
					id: "o",
					name: _("Office\npanel"),
					align: 'text-center text-pre',
					formatCell(td, v, row) {
						if (v) {
							td.gwCreateChild(Utils.useIcon('check'));
							td.classList.add('text-primary');
						}
					},
				}, {
					id: "c",
					name: _("Contact\nCenter"),
					align: 'text-center text-pre',
					formatCell(td, v, row) {
						if (v) {
							td.gwCreateChild(Utils.useIcon('check'));
							td.classList.add('text-primary');
						}
					},
				}, ];
			}
		}], this);
		this.licencesTable.setData([
			{s: 1, o: 1, c: 1, f: 'Připojení HW telefonu'},
			{s: 1, o: 1, c: 1, f: 'CDR - Přehled všech hovorů ústředny'},
			{s: 1, o: 1, c: 1, f: 'Reporty'},
			{s: 0, o: 1, c: 1, f: 'Volání pomocí webové aplikace'},
			{s: 0, o: 1, c: 1, f: 'Volání pomocí mobilní aplikace (Android, iOS)'},
			{s: 0, o: 1, c: 1, f: 'Grafické Callflow - IVR, časové podmínky, \nchytré směrování hovorů'},
			{s: 0, o: 1, c: 1, f: 'Generování hlášek pomocí TextToSpeech'},
			{s: 0, o: 1, c: 1, f: 'Řízení hovorů pomocí front'},
			{s: 0, o: 1, c: 1, f: 'Dělení na telefonní subsystémy podle \norganizačních jednotek'},
			{s: 0, o: 1, c: 1, f: 'Nahrávky hovorů'},
			{s: 0, o: 1, c: 1, f: 'SMS včetně hromadného rozesílání a šablon'},
			{s: 0, o: 1, c: 1, f: 'API pro komunikaci s ústřednou'},
			{s: 0, o: 0, c: 1, f: 'Agent panel'},
			{s: 0, o: 0, c: 1, f: 'Supervizor panel'},
			{s: 0, o: 0, c: 1, f: 'Odchozí kampaně'},
			{s: 0, o: 0, c: 1, f: 'Wallboard'},
		])
	},
})

// {{{ OfferDetail.Screen

GW.define('OfferDetail.Screen', 'Main.Screen', {
	offerId: null,
	offer: null,

	async 'after:initComponent'() {

		const params = new URLSearchParams(document.location.search);
		const justCreated = params.has('justCreated');
		if (justCreated) {
			console.log('Offer has just created!');
			// @TODO: is this done right in "GW way"?
			history.replaceState({}, document.location.pathname, document.location.pathname);
		}
		
		let inactiveReason = null;
		let derivedOfferId = null;

		if (this.offerId) {
			const offer = await REST.GET('offers/' + this.offerId + '/offer_data');
			this.offer = offer.offer_data;
			this.offer.public_id = offer.public_id;
			this.offer.id = offer.id;
			inactiveReason = offer.inactive_reason;
			derivedOfferId = offer.derived_offer_id;
		}

		this.titleEl.textContent = _('Nabídka ' + this.offerId);

		const steps = NewOffer.Screen.prototype.getSteps().map(step => ({
			label: step.name,
		}));

		this.bodyEl.gwCreateChild({
			className: 'page-wrapper',
			children: [{
				':skip': !justCreated,
				children: [{
					ref: 'stepper',
					xtype: 'Widgets.Stepper',
					disabled: true,
					getSteps: () => steps,
					step: steps.length,
				}],
			}, {
				':skip': !inactiveReason,
				className: 'offer-inactive-alert',
				children: inactiveReason === 'derived' ? [{
					nodeName: 'strong',
					textContent: _('Tato nabídka je neaktivní: '),
				}, {
					nodeName: 'a',
					href: APP_BASE + 'offers/' + derivedOfferId,
					textContent: _('Byla vytvořena novější nabídka'),
					'on:click': (e) => {
						e.preventDefault();
						Application.pushRoute(APP_BASE + 'offers/' + derivedOfferId);
					},
				}] : [{
					nodeName: 'strong',
					textContent: _('Tato nabídka je neaktivní: '),
				}, {
					nodeName: 'span',
					textContent: _('Nabídka po splatnosti'),
				}],
			}, {
				xtype: 'OfferDetail.PDF',
				offerId: this.offerId,
			}, { nodeName: 'br' }]
		}, this);

		this.bodyEl.gwCreateChild({
			className: 'form-buttons fixed',
			children: [{
				nodeName: 'button',
				type: 'button',
				className: 'button secondary icon-left',
				children: [Utils.useIcon('arrow-simple-left'), _( justCreated ? 'Seznam nabídek' : 'Zpět')], // OfferDetail.Screen
				'on:click': (ev) => {
					ev.preventDefault();
					Application.pushRoute(APP_BASE + 'offers');
				},
			}, {
				':skip': !Application.userHasPermission('offers.view_budget'),
				nodeName: 'a',
				href: APP_BASE + 'budget' + (this.offerId ? '/' + this.offerId : ''),
				className: 'button secondary icon-left',
				children: [Utils.useIcon('chart'), _('Rozpočetka')],
			},{
				nodeName: 'button',
				type: 'button',
				className: 'button primary ml-auto',
				children: [_('Poslat nabídku e-mailem')],
				'on:click': () => this.prepareIndicativeOfferEmail()
			}, {
				nodeName: 'a',
				href: APP_BASE + 'api/offers/' + (this.offerId) + '/pdf?download=1',
				className: 'button primary icon-right',
				children: [_('Export do PDF'), Utils.useIcon('file-pdf')],
			}]
		}, this);
	},

	prepareIndicativeOfferEmail() {
		const to = this.offer.company_rep_email || '';
		const companyName = this.offer.company_name || '';
		const companyRepName = this.offer.company_rep_name || '';
		const salesRepName = this.offer.sales_rep_name || '';
		const salesRepEmail = this.offer.sales_rep_email || '';
		const baseUrl = window.location.origin;

		const publicUrl = `${baseUrl}/api/public/offers/${this.offer.id}/pdf?publicId=${this.offer.public_id}`;

		const subject = `TMCZ Nabídka ${this.offer.id} pro ${companyName}`;

		const bodyLines = [
			companyRepName ? `Dobrý den ${companyRepName},` : 'Dobrý den,',
			'',
			'posílám Vám odkaz na připravenou nabídku:',
			publicUrl,
			'',
			'Pokud budete mít jakékoli dotazy, dejte mi prosím vědět.',
			'',
			'S pozdravem,',
			salesRepName,
			salesRepEmail
		];

		const body = bodyLines.join('\n');

		window.location.href = `mailto:${encodeURIComponent(to)}` +
			`?subject=${encodeURIComponent(subject)}` +
			`&body=${encodeURIComponent(body)}`;
	}
});

// }}}
// {{{ OfferDetail.Screen

GW.define('PublicOfferPrintDetail.Screen', 'Main.Screen', {
	offerPublicId: null,

	async 'after:initComponent'() {
		this.el.classList.add('screen-print-media');
		
		const offer = await REST.GET('public/offers/' + this.offerPublicId + '/offer_data');
		
		this.titleEl.textContent = _('Nabídka ' + offer.id);

		this.bodyEl.gwCreateChild({
			className: 'page-wrapper',
			children: [{
				xtype: 'OfferDetail',
				offerId: offer.id,
				lang: offer.language,
				getData: () => ({...offer.offer_data, id: offer.id, translations: offer.translations}),
			}, { nodeName: 'br' }]
		}, this);
	},
});

// }}}
// {{{ OfferDetail

/**
 * Component to render HTML of given offer (offer data).
 * 
 * The logic in this function is tied to the data structure generated in BE function offer_calculate_offer_data().
 */
GW.define('OfferDetail', 'GW.Component', {
	lang: '',
	getLanguage: null,

	getCompanyName: () => 'BusinessCom',
	getFooterHomepage: () => 'businesscom.cz',
	getFooterAddress1: () => 'BusinessCom a.s., se sídlem Dobrušská 1797/1,',
	getFooterAddress2: () => '147 00  Praha 4, IČO: 274 26 653, Spisová značka B 10552',
	getFooterAddress3: () => 'vedená u Městského soudu v Praze',

	translations: {
		cs: {
			offerTitlePrefix: 'Orientační nezávazná nabídka',
			offerTitleProduct: 'MPBX BC4 Cloud',

			offerId: 'ID nabídky',
			createdOn: 'Vytvořeno dne',
			validUntil: 'Platnost do',

			documentGoal: 'Cíl dokumentu',
			documentGoalText: 'Cílem tohoto dokumentu je poskytnout zákazníkovi rychlou orientační informaci o pravděpodobné možnosti zřízení vybrané služby v požadované lokalitě a odhadnout cenu za zřízení a poskytování takové služby.',

			customer: 'Zákazník',
			customerName: 'Zákazník',
			customerContact: 'Kontaktní osoba',
			customerAddress: 'Adresa sídla zákazníka',

			offerSubject: 'Předmět nabídky',
			piecesShort: 'ks',
			priceIncludes: 'Cena obsahuje:',

			totalMonthly: 'Celková měsíční cena bez DPH',
			totalOneTime: 'Celková jednorázová cena bez DPH',

			offerSummary: 'Shrnutí nabídky',
			totalMonthlyBefore: 'Celková pravidelná měsíční cena',
			totalOneTimeBefore: 'Celková jednorázová cena',
			discount: 'Sleva',
			totalMonthlyAfter: 'Celková pravidelná měsíční cena po slevě',
			totalOneTimeAfter: 'Celková jednorázová cena po slevě',
			contractDuration: 'Smluvní závazek',
			monthsSuffix: 'měsíců',

			forPrefix: 'Za',
			preparedBy: 'nabídku připravil (kontaktní osoba poskytovatele)',
			repName: 'Jméno a příjmení',
			repEmail: 'Email',
			repPhone: 'Telefon',

			czechButton: 'Česky',
			withoutVat: 'bez DPH',
		},
		en: {
			offerTitlePrefix: 'Non-binding indicative offer',
			offerTitleProduct: 'MPBX BC4 Cloud',

			offerId: 'Offer ID',
			createdOn: 'Created on',
			validUntil: 'Valid until',

			documentGoal: 'Document purpose',
			documentGoalText: 'The purpose of this document is to provide the customer with a quick indicative evaluation of service availability at the requested location and an estimate of installation and service fees.',

			customer: 'Customer',
			customerName: 'Customer',
			customerContact: 'Contact person',
			customerAddress: 'Registered address',

			offerSubject: 'Offer content',
			piecesShort: 'pcs',
			priceIncludes: 'Price includes:',

			totalMonthly: 'Total monthly price excl. VAT',
			totalOneTime: 'Total one-time price excl. VAT',

			offerSummary: 'Offer summary',
			totalMonthlyBefore: 'Total regular monthly fee',
			totalOneTimeBefore: 'Total one-time fee',
			discount: 'Discount',
			totalMonthlyAfter: 'Total monthly fee after discount',
			totalOneTimeAfter: 'Total one-time fee after discount',
			contractDuration: 'Contract commitment',
			monthsSuffix: 'months',

			forPrefix: 'For',
			preparedBy: 'offer prepared by (provider contact person)',
			repName: 'Name and surname',
			repEmail: 'Email',
			repPhone: 'Phone',

			czechButton: 'Czech',
			withoutVat: 'excl. VAT',
		},
	},

	getCurrentLang() {
		return this.lang || i18n.lang || 'cs';
	},

	tr(key) {
		const lang = this.getCurrentLang();
		const dict = this.translations[lang] || this.translations.cs || {};
		return dict[key] || key;
	},


	async applyLanguageToOfferData() {
		if (!this.offerData || !this.offerData.categories) {
			return;
		}

		const lang = this.getCurrentLang();

		if (lang !== 'cs') {
			// In case of public printing of offer translations are part of the offer
			let result = this.offerData.translations;
			if (!result) {
				result = (await REST.POST(`offers/calculate/budget-data/translation`, {
					language: lang,
					product: this.offerData.product,
					public_id: this.offerData.public_id
				}));
			}

			const translations = result.translations.reduce((obj, t) => {
				obj.categories.set(t.czech_category, t.category);
				obj.items.set(t.product_id, t.name);
				return obj;
			}, {categories: new Map(), items: new Map()});

			this.offerData.categories = this.offerData.categories.map(c => {
				c.czech_category = c.czech_category || c.name;
				const translatedCategory = translations.categories.get(c.czech_category);
				if (translatedCategory) {
					c['name_' + lang] = translatedCategory;
				}

				c.items = c.items.map(i => {
					const translatedItem = i.id && translations.items.get(i.id);
					if (i.id && (!/^(custom_|hw__)/.test(i.id) || translatedItem)) {
						i.czech_name = i.czech_name || i.name;
						i.name = translatedItem;
					}
					return i;
				});
				return c;
			});
		} else {
			this.offerData.categories = this.offerData.categories.map(c => {
				c.name = c.czech_category || c.name;
				c.items = c.items.map(i => {
					i.name = i.czech_name || i.name;
					return i;
				});
				return c;
			});
		}
	},

	async changeLanguage(lang) {
		this.lang = lang;

		if (this.offerDetail && this.offerDetail.gwReplaceChildren) {
			this.offerDetail.gwReplaceChildren([]);
		}

		await this.applyLanguageToOfferData();
		this.renderOffer();
	},

	'after:initComponent'() {
		const params = new URLSearchParams(location.search);
		const urlLang = params.get('lang');

		if (urlLang && this.translations[urlLang]) {
			this.lang = urlLang;
		} else {
			this.lang = this.getLanguage && this.getLanguage() || this.getCurrentLang();
		}

		const me = this;

		this.el = document.gwCreateElement({
			className: 'panel-container page-centered-container',
			children: [{
				className: 'header',
				children: [{
					ref: 'logoElContentHeader',
					className: 'logo',
					// children: [Utils.useIcon('logo')]
					children: [{nodeName: 'img', src: '/icons/logo-color.svg'}]
				}, {
					ref: 'headerTextContent',
					className: 'info text-muted',
					children: me.getHeaderTextContent()
				}]
			}, {
				className: 'content',
				ref: 'offerDetail',
			}, {
				className: 'footer',
				children: [{
					ref: 'logoElContentFooter',
					className: 'logo',
					// children: [Utils.useIcon('logo')]
					children: [{nodeName: 'img', src: '/icons/logo-color.svg'}]
				}, {
					className: 'subtitle',
					textContent: this.getFooterHomepage(),
				}, {
					ref: 'footerAddress',
					className: 'address',
					children: this.getFooterAddress()
				}]
			}],
		}, this);

		this.monDom(window, "beforeprint", () => {
			const title = document.title;
			document.title = `CN - ${this.offerData.id} - ${Formats.date(this.offerData.offered_on)} - ${this.offerData.company_name}`;
			document.documentElement.setAttribute('data-theme', 'light');

			this.monDom(window, 'afterprint', () => {
				document.title = title;
			});
		}, this);

		this.reload();
	},

	async getData() {
		return {};
	},

	async reload() {
		this.offerData = await this.getData();
		await this.applyLanguageToOfferData();

		this.renderOffer();
	},

	renderOffer() {
		const tr = this.tr.bind(this);

		if (!this.offerData) {
			return;
		}

		this.footerAddress.gwReplaceChildren(this.getFooterAddress(), this);
		this.headerTextContent.gwReplaceChildren(this.getHeaderTextContent(), this);

		if (this.offerData.id) {
			this.offerIdEl.textContent = this.offerData.id;
			if (this.justCreated) {
				this.offerIdEl.classList.add('stamp');
			}
		} else {
			this.offerIdEl.textContent = 'BC4XXXXXXXXXX';
			this.offerIdEl.classList.add('vhidden');
		}
		this.createdEl.textContent = Formats.date(this.offerData.offered_on);
		this.expirationEl.textContent = Formats.date(this.offerData.expires_on);

		const languageSuffix = this.lang === 'cs' ? '' : '_' + this.lang;

		this.offerDetail.gwReplaceChildren([{
			className: 'section',
			children: [{
				nodeName: 'h4',
				textContent: tr('documentGoal'),
			}, {
				nodeName: 'p',
				textContent: tr('documentGoalText'),
			}]
		}, {
			className: 'section',
			children: [{
				nodeName: 'h4',
				textContent: tr('customer'),
			}, {
				className: 'grid grid-col-2',
				children: [
					{ textContent: tr('customerName') }, { textContent: this.offerData.company_name },
					{ textContent: tr('customerContact') }, { textContent: [this.offerData.company_rep_name, this.offerData.company_rep_email, this.offerData.company_rep_phone].filter(Boolean).join(', ') },
					{ textContent: tr('customerAddress') }, { textContent: this.offerData.company_address },
				]
			}]
		}, {
			className: 'section',
			children: [{
				':skip': this.offerData.categories.length === 0,
				nodeName: 'h4',
				textContent: tr('offerSubject'),
			}, ...this.offerData.categories.map(category => ({
				className: 'grid with-header with-totals',
				children: [
					{textContent: category['name' + languageSuffix]},
					{textContent: tr('piecesShort')},
					...category.items.flatMap(item => [
						{textContent: item['name' + languageSuffix] || item.name },
						{textContent: item.amount}
					]),
					...(category['includes_items' + languageSuffix] ? [{
						nodeName: 'p',
						textContent: tr('priceIncludes') + '\n' + category['includes_items' + languageSuffix].join('\n'),
					}, {
						nodeName: 'p',
					}] : [null]),
					...Object.entries(category.sums_by_sell_type)
						.sort((a, b) => (b[0] === 'monthly') - (a[0] === 'monthly')) // monthly first
						.flatMap(([sell_type, sum]) => [
							{
								className: 'totals',
								textContent: {
									'monthly': tr('totalMonthly'),
									'one_time': tr('totalOneTime'),
								}[sell_type],
							},
							{className: 'totals', textContent: Formats.currency_CZK(sum)}
						]),
				],
			}))]
		}, {
			className: 'section',
			children: [{
				nodeName: 'h4',
				textContent: tr('offerSummary'),
			}, {
				className: 'grid grid-col-2 with-totals m-0',
				children: [
					{textContent: tr('totalMonthlyBefore')},
					{textContent: Formats.currency_CZK(this.offerData.total?.monthly?.before_discount) + ' ' + tr('withoutVat')},
				]
			}, {
				className: 'grid grid-col-2 with-totals m-0',
				children: [
					{textContent: tr('totalOneTimeBefore')},
					{textContent: Formats.currency_CZK(this.offerData.total?.one_time?.before_discount) + ' ' + tr('withoutVat')},
				]
			}, {
				':skip': !this.offerData.total?.discount_percent,
				className: 'grid grid-col-2 with-totals m-0',
				children: [
					{textContent: tr('discount')},
					{textContent: this.offerData.total?.discount_percent + ' %'},
				]
			}, {
				':skip': !this.offerData.total?.discount_percent,
				className: 'grid grid-col-2 with-totals m-0',
				children: [
					{textContent: tr('totalMonthlyAfter')},
					{textContent: Formats.currency_CZK(this.offerData.total?.monthly?.after_discount) + ' ' + tr('withoutVat')},
				]
			}, {
				':skip': !this.offerData.total?.discount_percent,
				className: 'grid grid-col-2 with-totals m-0',
				children: [
					{textContent: tr('totalOneTimeAfter')},
					{textContent: Formats.currency_CZK(this.offerData.total?.one_time?.after_discount) + ' ' + tr('withoutVat')},
				]
			}, {
				className: 'grid grid-col-2 m-top',
				children: [
					{textContent: tr('contractDuration')},
					{textContent: this.offerData.contract_duration_months + ' ' + tr('monthsSuffix')},
				]
			}]
		}, {
			className: 'section',
			children: [{
				nodeName: 'h4',
				textContent: `${tr('forPrefix')} ${this.getCompanyName()} ${tr('preparedBy')}`,
			}, {
				className: 'grid grid-col-2',
				children: [
					{ textContent: tr('repName') }, { textContent: this.offerData.sales_rep_name },
					{ textContent: tr('repEmail') }, { textContent: this.offerData.sales_rep_email },
					{ textContent: tr('repPhone') }, { textContent: this.offerData.sales_rep_phone },
				]
			}]
		}], this);
	},

	getHeaderTextContent() {
		const me = this;

		return [{
			className: 'title',
			children: [
				{nodeName: 'span', textContent: me.tr('offerTitlePrefix')},
				' ',
				{nodeName: 'span', textContent: me.tr('offerTitleProduct')},
			]
		}, {
			children: [
				{nodeName: 'span', textContent: me.tr('offerId') + ': '},
				{nodeName: 'span', ref: 'offerIdEl', className: 'id'},
			]
		}, {
			children: [
				{nodeName: 'span', textContent: me.tr('createdOn') + ': '},
				{nodeName: 'span', ref: 'createdEl'},
				{nodeName: 'span', textContent: ', '},
				{nodeName: 'span', textContent: me.tr('validUntil') + ': '},
				{nodeName: 'span', ref: 'expirationEl'}
			]
		}]
	},

	getFooterAddress() {
		const footerSectionLanguageSuffix = this.lang === 'cs' ? '' : '_' + this.lang;

		return [
			{textContent: this['getFooterAddress1' + footerSectionLanguageSuffix]()},
			{textContent: this['getFooterAddress2' + footerSectionLanguageSuffix]()},
			{textContent: this['getFooterAddress3' + footerSectionLanguageSuffix]()},
		]
	}
});

GW.define('OfferDetail.PDF', 'GW.Component', {
	
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'panel-container page-centered-container',
			children: [{
				className: 'pdf-pages',
				ref: 'pagesEl',
				children: [{
					title: _('Probíhá generování PDF souboru'),
					children: [Utils.useIcon('loading', {cls: 'icon-rotate text-primary'})],
				}],
			}],
		}, this);

		const { pdfjsLib } = globalThis;

		pdfjsLib.GlobalWorkerOptions.workerSrc = '/pdfjs/pdf.worker.mjs';

		// Asynchronous download of PDF
		let loadingTask = pdfjsLib.getDocument(`/api/offers/${this.offerId}/pdf`);
		loadingTask.promise.then((pdf) => {

			// this will make it more crisp, leaving antialeasing on the browser (at least on Chrome, Firefox, Windows)
			const scale = 2; 

			const ratio = window.devicePixelRatio || 1

			function renderPage(pageNumber, canvas) {
				pdf.getPage(pageNumber).then(function(page) {
					const viewport = page.getViewport({ 
						scale: scale * ratio, 
					});
					canvas.height = viewport.height;
					canvas.width = viewport.width;
					page.render({canvasContext: canvas.getContext('2d'), viewport: viewport});
				});
			}

			this.pagesEl.textContent = '';

			for(let page = 1; page <= pdf.numPages; page++) {
				let canvas = document.createElement("canvas");
				canvas.className = 'pdf-page-canvas';
				this.pagesEl.appendChild(canvas);
				renderPage(page, canvas);
			}
		}, reason => {
			// PDF loading error
			console.error(reason);
			this.pagesEl.gwReplaceChildren([{
				className: 'text-error',
				textContent: _('PDF se nepodařilo načíst'),
			}]);
		});
	}
	
});

// }}}

// {{{ Budget.Screen

GW.define('Budget.Screen', 'Main.Screen', {
	offerId: null,

	// loaded data from 'offers/{offerId}/budget_data'
	offer: null,
	
	budgetData: null,

	async 'after:initComponent'() {
		this.offer = null;
		if (this.offerId) {
			this.offer = await REST.GET('offers/' + this.offerId + '/budget_data');
		}

		this.titleEl.textContent = _('Nabídka ' + this.offerId);

		this.bodyEl.gwCreateChild({
			className: 'page-wrapper',
			children: [{
				ref: 'budgetTable',
				xtype: 'BudgetTable',
				getData: () => this.offer,
			}],
		}, this);

		this.bodyEl.gwCreateChild({
			className: 'form-buttons fixed',
			children: [{
				nodeName: 'button',
				type: 'button',
				className: 'button secondary icon-left',
				children: [Utils.useIcon('arrow-simple-left'), _('Zpět')], // Budget.Screen
				'on:click': (ev) => {
					ev.preventDefault();
					Application.pushRoute(APP_BASE + 'offers');
				},
			}, {
				':skip': !Application.userHasPermission('offers.view_offer'),
				nodeName: 'a',
				href: APP_BASE + 'offers' + (this.offerId ? '/' + this.offerId : ''),
				className: 'button secondary icon-left',
				children: [Utils.useIcon('eye'), _('Cenová nabídka')],
			},{
				nodeName: 'button',
				type: 'button',
				className: 'button primary ml-auto',
				children: [_('Anglicky')],
				'on:click': async (ev) => {
					const switchToLang = ev.target.textContent === 'Česky' ? 'cs' : 'en'
					ev.target.textContent = switchToLang === 'cs' ? _('Anglicky') : _('Česky');
					await this.budgetTable.changeLanguage(switchToLang);
				}
			}, {
				nodeName: 'button',
				type: 'button',
				className: 'button primary icon-right btn-export',
				children: [_('Export do XLSX'), Utils.useIcon('file-xls')],
				'on:click': (ev) => {
					ev.preventDefault();
					Export.xlsx({
						filename: _('Nabídka ' + this.offerId) + '.xlsx',
						sheets: this.budgetTable.getXlsxExportData(),
					});
				}
			}, {
				nodeName: 'button',
				type: 'button',
				className: 'button primary icon-right btn-export',
				children: [_('Export do PDF'), Utils.useIcon('file-pdf')],
				'on:click': (ev) => {
					ev.preventDefault();
					window.print();
				}
			}]
		}, this);
	},
});

// }}}
// {{{ BudgetTable

GW.define('BudgetTable', 'GW.Component', {
	// offer data from 'api/offers/{offerId}/budget_data'
	data: null,

	showCheckboxes: true,
	lang: 'cs',
	getLanguage: null,

	// category.id is not unique (used for permission), need to use index
	selectedCategoryIndices: new Set(),

	// --- Local i18n dictionaries ---
	translations: {
		cs: {
			// XLSX – sheet & labels
			contactsSheetName: 'Kontakty',
			labelOfferId: 'ID nabídky',
			labelOfferCreated: 'Datum vytvoření nabídky',

			supplier: 'Dodavatel',
			salesRep: 'Obchodní zástupce',
			name: 'Jméno',
			phone: 'Telefon',
			email: 'E-mail',

			customer: 'Zákazník',
			companyRegNumber: 'IČ',
			companyName: 'Název firmy',
			companyAddress: 'Sídlo',

			customerResponsiblePerson: 'Zodpovědná osoba zákazníka',
			pbxAdmin: 'Administrátor pro SIP trunk/PBX',
			systemAdmin: 'Administrátor systémových řešení (ADSR)',

			// sell types
			sellTypeMonthly: 'měsíčně',
			sellTypeOneTime: 'jednorázově',

			// misc
			monthsSuffix: 'měsíců',
			quantity: 'Počet',

			unitCostPricePrefix: 'Jednotková nákladová cena ',
			totalCostPricePrefix: 'Celková nákladová cena ',
			unitSellPricePrefix: 'Jednotková prodejní cena ',
			totalSellPricePrefix: 'Celková prodejní cena ',

			totalLabel: 'Celkem',

			noResults: 'Žádné výsledky',
			exportCategoryTitle: 'Vybrat jenom tuto kategorii do exportu',
		},
		en: {
			// XLSX – sheet & labels
			contactsSheetName: 'Contacts',
			labelOfferId: 'Offer ID',
			labelOfferCreated: 'Offer creation date',

			supplier: 'Supplier',
			salesRep: 'Sales representative',
			name: 'Name',
			phone: 'Phone',
			email: 'E-mail',

			customer: 'Customer',
			companyRegNumber: 'Company reg. number',
			companyName: 'Company name',
			companyAddress: 'Registered address',

			customerResponsiblePerson: 'Customer responsible person',
			pbxAdmin: 'SIP trunk/PBX administrator',
			systemAdmin: 'System solutions administrator (ADSR)',

			// sell types
			sellTypeMonthly: 'per month',
			sellTypeOneTime: 'one-off',

			// misc
			monthsSuffix: 'months',
			quantity: 'Quantity',

			unitCostPricePrefix: 'Unit cost price ',
			totalCostPricePrefix: 'Total cost price ',
			unitSellPricePrefix: 'Unit sale price ',
			totalSellPricePrefix: 'Total sale price ',

			totalLabel: 'Total',

			noResults: 'No results',
			exportCategoryTitle: 'Export only this category',
		},
	},

	// current language – component-local or global i18n.lang
	getCurrentLang() {
		return this.lang || i18n.lang || 'cs';
	},

	// translation helper
	tr(key) {
		const lang = this.getCurrentLang();
		const dict = this.translations[lang] || this.translations.cs || {};
		return dict[key] || key;
	},

	async changeLanguage(lang) {
		this.lang = lang;
		await this.reload()
	},

	async applyLanguageToOfferData() {
		const lang = this.getCurrentLang();
		if (lang !== 'cs') {
			const translations = (await REST.POST(`offers/calculate/budget-data/translation`, {
				language: lang,
				product: this.data.product
			})).translations.reduce((obj, t) => {
				obj.categories.set(t.czech_category, t.category);
				obj.items.set(t.product_id, t.name);
				return obj;
			}, {categories: new Map(), items: new Map()});

			this.data.budget_data.categories = this.data.budget_data.categories.map(c => {
				c.czech_category = c.czech_category || c.name;
				c.name = translations.categories.get(c.czech_category);
				c.items = c.items.map(i => {
					if (i.id && !/^(custom_|hw__)/.test(i.id)) {
						i.czech_name = i.czech_name || i.name;
						i.name = translations.items.get(i.id);
					}
					return i;
				});
				return c;
			})
		} else {
			this.data.budget_data.categories = this.data.budget_data.categories.map(c => {
				c.name = c.czech_category || c.name;
				c.items = c.items.map(i => {
					i.name = i.czech_name || i.name;
					return i;
				});
				return c;
			})
		}
	},

	initComponent() {
		const params = new URLSearchParams(location.search);
		const urlLang = params.get('lang');

		if (urlLang && this.translations[urlLang]) {
			this.lang = urlLang;
		} else {
			this.lang = this.getLanguage && this.getLanguage();
		}

		this.el = document.gwCreateElement({
			ref: 'budgetTable',
		}, this);

		this.reload();
	},

	async getData() {
		// to be defined by parent component
		return {};
	},

	getXlsxExportData() {
		const {budget_data, id, created} = this.data;
		const {contract_duration_months, contact_data, categories} = budget_data;

		return [(() => {
			if (!contact_data) {
				return;
			}
			const row_data = {
				...contact_data,
				offer_id: id,
				created: created,
			};
			// render contacts as the first sheet
			return {
				name: this.tr('contactsSheetName'),
				columns: [{
					id: 'name',
					name: '',
					width: 38,
				}, {
					id: 'value',
					name: '',
					width: 40,
				}],
				rows: [{
					name: 'offer_id',
					label: this.tr('labelOfferId'),
				},{
					name: 'created',
					label: this.tr('labelOfferCreated'),
					format: 'date',
				},{
					// empty row
					label: '',
				},{
					label: this.tr('supplier'),
				}, {
					label: this.tr('salesRep'),
				},{
					name: 'sales_rep_name',
					label: this.tr('name'),
				}, {
					name: 'sales_rep_phone',
					label: this.tr('phone'),
				}, {
					name: 'sales_rep_email',
					label: this.tr('email'),
				}, {
					// empty row
					label: '',
				}, {
					label: this.tr('customer'),
				}, {
					name: 'company_reg_number',
					label: this.tr('companyRegNumber'),
				}, {
					name: 'company_name',
					label: this.tr('companyName'),
				}, {
					name: 'company_address',
					label: this.tr('companyAddress'),
				}, {
					// empty row
					label: '',
				}, {
					label: this.tr('customerResponsiblePerson'),
				}, {
					name: 'company_rep_name',
					label: this.tr('name'),
				}, {
					name: 'company_rep_phone',
					label: this.tr('phone'),
				}, {
					name: 'company_rep_email',
					label: this.tr('email'),
				}, {
					// empty row
					label: '',
				}, {
					label: this.tr('pbxAdmin'),
				}, {
					name: 'company_pbx_admin_name',
					label: this.tr('name'),
				}, {
					name: 'company_pbx_admin_phone',
					label: this.tr('phone'),
				}, {
					name: 'company_pbx_admin_email',
					label: this.tr('email'),
				}, {
					// empty row
					label: '',
				}, {
					label: this.tr('systemAdmin'),
				}, {
					name: 'company_system_admin_name',
					label: this.tr('name'),
				}, {
					name: 'company_system_admin_phone',
					label: this.tr('phone'),
				}, {
					name: 'company_system_admin_email',
					label: this.tr('email'),
				}].map(({name, label, format}) => ({
					// construct a row with attributes matching the table column ids
					name: label,
					value: (() => {
						if (!name) {
							return '';
						}
						const value = row_data[name];
						return {value, format};
					})(),
				})),
			};
		})(), ...categories
			.filter((c, i) => this.selectedCategoryIndices.size === 0 || this.selectedCategoryIndices.has(i))
			.map(category => {
				// sheet for every selected category
				let name = category.name;
				if (name.startsWith('Výstupy pro rozpočetku ')) {
					// shorten the name to make the sheet name less than 31 characters
					name = name.substring('Výstupy pro rozpočetku '.length);
				}
				if (category.sell_type) {
					// add this info to avoid sheets with same name
					name += ' - ' + {
						'monthly': this.tr('sellTypeMonthly'),
						'one_time': this.tr('sellTypeOneTime'),
					}[category.sell_type];
				}
				return {
					name,
					...this.getTableData(contract_duration_months, category, true),
				};
			})
		].filter(s => s);
	},

	getTableData(contract_duration_months, category, xlsexport) {
		return {
			// this is used for both SmartTable and excel export (which uses 'width' field)
			columns: [{
				visible: true,
				id: "name",
				name: category.name
					+ (category.sell_type ? (' - ' + {
						'monthly': this.tr('sellTypeMonthly'),
						'one_time': this.tr('sellTypeOneTime'),
					}[category.sell_type]) : '')
					+ (contract_duration_months
						? (' (' + contract_duration_months + ' ' + this.tr('monthsSuffix') + ')')
						: ''),
				width: 60,
			}, {
				visible: true,
				id: "amount",
				name: this.tr('quantity'),
				format: 'integer',
				width: 10,
			}, {
				visible: Application.userHasPermission(`budget.cost_price.${category.id}`),
				id: "cost_price",
				name: this.tr('unitCostPricePrefix') + THEME.getCompanyNameShort(),
				format: 'currency_CZK',
				width: 20,
			}, {
				visible: Application.userHasPermission(`budget.cost_price.${category.id}`),
				id: "cost_total",
				name: this.tr('totalCostPricePrefix')+ THEME.getCompanyNameShort(),
				format: 'currency_CZK',
				width: 20,
			}, {
				visible: Application.userHasPermission(`budget.sell_price.${category.id}`),
				id: "sell_price",
				name: this.tr('unitSellPricePrefix') + THEME.getCompanyNameShort(),
				format: 'currency_CZK',
				width: 20,
			}, {
				visible: Application.userHasPermission(`budget.sell_price.${category.id}`),
				id: "sell_total",
				name: this.tr('totalSellPricePrefix') + THEME.getCompanyNameShort(),
				format: 'currency_CZK',
				width: 20,
			}].filter(c => c.visible).map(({visible, ...rest}) => rest),

			rows: [
				...category.items.map((k, i) => {
					const row = i + 2;
					return {
						name: k.name,
						amount: k.amount,
						cost_price: k.cost_price,
						cost_total: xlsexport ? `=B${row}*C${row}` : k.cost_price * k.amount,
						sell_price: k.sell_price,
						sell_total: xlsexport ? `=B${row}*E${row}` : k.sell_price * k.amount,
					};
				}),
				...(category.items.length ?
						[xlsexport ? {
							name: {style: 'total', value: this.tr('totalLabel')},
							amount: {style: 'total'},
							cost_price: {style: 'total'},
							cost_total: {style: 'total', value: `=SUM(D2:D${category.items.length + 1})`},
							sell_price: {style: 'total'},
							sell_total: {style: 'total', value: `=SUM(F2:F${category.items.length + 1})`},
						} : {
							name: this.tr('totalLabel'),
							cost_total: category.items.reduce((acc, k) => acc + (k.cost_price * k.amount), 0),
							sell_total: category.items.reduce((acc, k) => acc + (k.sell_price * k.amount), 0),
						}] : []
				),
			],
		};
	},

	async reload() {
		this.data = await this.getData();
		await this.applyLanguageToOfferData();
		this.render();
	},

	async render() {
		const {budget_data} = this.data;
		const {categories, contract_duration_months} = budget_data;

		// při opakovaném reloadu (třeba po changeLanguage) vyčisti tabulky
		if (this.budgetTable && this.budgetTable.gwReplaceChildren) {
			this.budgetTable.gwReplaceChildren([]);
		}

		categories.forEach((category, i) => {
			const {columns, rows} = this.getTableData(contract_duration_months, category, false);
			let self = this;

			this.budgetTable.gwCreateChild({
				xtype: 'SmartTable',
				extraClass: 'table-accented budget-table totals-last-row export-selected',
				emptyText: this.tr('noResults'),
				'after:initComponent'() {
					if (self.showCheckboxes) {
						this.el.gwCreateChild({
							className: 'budget-table-checkbox',
							children: [{
								className: 'check',
								children: [{
									ref: 'input',
									nodeName: 'input',
									type: 'checkbox',
									title: self.tr('exportCategoryTitle'),
									'on:input': e => {
										if (e.target.checked) {
											self.selectedCategoryIndices.add(i);
										} else {
											self.selectedCategoryIndices.delete(i);
										}
										self.el.querySelectorAll('.budget-table').forEach((el, i) => {
											const selected = self.selectedCategoryIndices.size === 0 || self.selectedCategoryIndices.has(i);
											el.classList.toggle('export-selected', selected);
										});
									},
								}],
							}]
						});
					}
				},
				getColumns: () => columns,
				rows,
			});
		});
	},
});
// }}}

// {{{ PriceChange.Screen

function XLSXTableMixin(columns) {
	return {
		async exportXlsx(name, rows) {
			await Export.xlsx({
				filename: `${name}.xlsx`,
				sheets: [{
					name,
					columns,
					rows,
				}],
			});
		},

		async importXlsx() {
			// select file
			const file = await Uploads.fileSelect('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

			// convert XLSX to data array
			let data = await Uploads.uploadFile('import/xlsx', file, {
				headers: {
					'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				},
			});

			// convert the XLSX data to rows array

			const cols = data[0].map(s => columns.find(c => c.name === s));
			// TODO check header contains all required columns

			const unformat = (format, value) => {
				if (format === 'currency_CZK') {
					return +value;
				}
				if (format === 'bool') {
					return value === Formats.bool(true);
				}
				return value;
			};

			return data.slice(1).map(row => Object.fromEntries(row.map((v, i) => [
				cols[i].id, // use the column id
				unformat(cols[i].format, v),
			])));
		},
	};
}

GW.define('PriceChange.Table', 'GW.Component', {

	product: null,
	prices: [],

	async reloadPrices() {
		this.prices = (await REST.GET('prices', {product: this.product})).price_list;
		this.table.setData(this.prices.flatMap((item, i) => {
			const res = [];
			if (item.category !== this.prices[i - 1]?.category) {
				res.push({
					__category_title: item.category,
				});
			}
			res.push(item);
			return res;
		}));
	},

	initComponent() {
		this.el = document.gwCreateElement({
			children: [{
				className: 'page-heading-controls',
				children: [{
					nodeName: 'button',
					type: 'button',
					className: 'button secondary small icon-left',
					children: [Utils.useIcon('plus'), _('Produkty')],
					'on:click': async () => this.assignHardwareProductsToOfferProduct(),
				},{
					nodeName: 'button',
					type: 'button',
					className: 'button secondary small icon-left',
					children: [Utils.useIcon('import'), _('Import XLSX')],
					'on:click': async () => {
						const rows = await this.importXlsx();
						await REST.PUT('prices?product=' + encodeURIComponent(this.product), rows);
						await this.reloadPrices();
					},
				}, {
					nodeName: 'button',
					type: 'button',
					className: 'button secondary small icon-left',
					children: [Utils.useIcon('export'), _('Export XLSX')],
					'on:click': async () => {
						await this.exportXlsx(_('Ceník {product}').replace('{product}', this.product), this.prices);
					},
				}],
			}, {
				xtype: 'SmartTable',
				extraClass: 'table-alternative',
				ref: 'table',
				
				renderRow(tr, item) {
					if (item.__category_title) {
						tr.classList.add('header');
						tr.gwReplaceChildren([{
							nodeName: 'th',
							'attr:colspan': 4,
							textContent: item.__category_title,
						}]);
					}
				},
				
				getColumns() {
					return [{
						id: "name",
						name: _("Název produktu"),
					}, {
						id: "description",
						name: _("Popis produktu"),
					}, {
						id: "cost_price",
						name: _("Nákladová cena (CZK)"),
						format: 'currency_CZK',
						align: 'right',
					}, {
						id: "sell_price",
						name: _("Prodejní cena (CZK)"),
						format: 'currency_CZK',
						align: 'right',
					}];
				},
			}],
		}, this);

		this.reloadPrices();
	},

	async assignHardwareProductsToOfferProduct() {
		const me = this;
		const hardwareProducts = (await REST.GET(`prices-hardware`)).prices;
		const assignedProducts = (await REST.GET(`prices-hardware/offer-product/${me.product}`))
			.reduce((set, pr) => {
				set.add(pr.price_hardware_id);
				return set;
			}, new Set());

		new Main.FormDialog({
			title: _('Přiřazení hardwarových produktů k nabídce'),
			renderFormFields() {
				return hardwareProducts.map(pr => ({
					xtype: 'AckCheckboxField',
					optional: true,
					name: `${me.product}___${pr.id}`,
					shortText: _('Produkt ') + pr.name,
					value: assignedProducts.has(pr.id)
				}))
			},
			async onSave(data) {
				const payload = [];
				for (const [id, value] of Object.entries(data)) {
					const [offer_product_id, price_hardware_id] = id.split('___');
					payload.push({
						price_hardware_id: Number(price_hardware_id),
						offer_product_id,
						assigned: value
					})
				}
				await REST.POST(`prices-hardware/offer-product`, payload);
			},
		});
	},

	...XLSXTableMixin([{
		id: "id",
		name: _("ID produktu"),
		width: 24,
	}, {
		id: "name",
		name: _("Název produktu"),
		width: 28,
	}, {
		id: "description",
		name: _("Popis produktu"),
		width: 30,
	}, {
		id: "cost_price",
		name: _("Nákladová cena (CZK)"),
		format: 'currency_CZK',
		align: 'right',
		width: 20,
	}, {
		id: "sell_price",
		name: _("Prodejní cena (CZK)"),
		format: 'currency_CZK',
		align: 'right',
		width: 20,
	}]),

})


GW.define('PriceChange.Hardware', 'GW.Component', {

	async reloadPrices() {
		const prices = await REST.GET('prices-hardware');
		this.table.setData(prices.prices);
	},
	
	async updateOrder() {
		const ordered_ids = [...this.table.el.querySelectorAll('tr.dnd-row [data-col=product_id]')]
			.map(e => e.textContent);

		try {
			await REST.POST('prices-hardware/set-order', {ordered_ids});
		} catch (e) {
			this.reloadPrices(); // revert the change
			throw e;
		}

		Application.notify({
			kind: 'success',
			text: _('Změna pořadí uložena'),
			timeout: 5000,
		});
	},

	initComponent() {
		const me = this;
		this.el = document.gwCreateElement({
			children: [{
				className: 'page-heading-controls',
				children: [{
					nodeName: 'button',
					type: 'button',
					className: 'button primary small icon-left',
					children: [Utils.useIcon('plus'), _('Přidat')],
					'on:click': async () => {
						new Main.FormDialog({
							title: _('Zadat ID produktu'),
							renderFormFields: () =>[{
								xtype: 'TextField',
								name: 'product_id',
								label: _('ID produktu'),
							}],
							onSave: async (data) => {
								await REST.POST('prices-hardware/add', {
									product_id_add: data.product_id,
								});
								this.reloadPrices();
							},
						});
					},
				}],
			}, {
				xtype: 'SmartTable',
				ref: 'table',
				
				'after:initComponent'() {
					this.dnd = DnDListSetup(this.body, {
						startFilterClass: 'drag-icon',
						itemClass: 'dnd-row',
						onDragEnd: () => {
							me.updateOrder();
						}
					});
				},
				'before:releaseComponent'() {
					this.dnd && this.dnd.destroy();
				},
				
				renderRow(tr) {
					tr.classList.add('dnd-row');
				},

				getColumns: () => [{
					id: 'ctl-dnd',
					name: "",
					formatCell: (td, v, row) => {
						td.gwCreateChild({
							nodeName: 'button',
							type: 'button',
							className: 'button secondary small icon-only drag-icon',
							title: _('Pomocí Drag&drop změníte pořadí položky'),
							children: [Utils.useIcon('dragindication')],
						});
					},
				}, {
					id: "product_id",
					name: _("ID produktu"),
					formatCell: (td, v, row) => {
						td.textContent = v;
						td.classList.add('text-nowrap');
					}
				}, {
					id: "name",
					name: _("Název produktu"),
				}, {
					id: "description",
					name: _("Popis produktu"),
				}, {
					id: "cost_price",
					name: _("Nákladová cena (CZK)"),
					format: 'currency_CZK',
					align: 'right',
				}, {
					id: "sell_price",
					name: _("Prodejní cena (CZK)"),
					format: 'currency_CZK',
					align: 'right',
				}, {
					id: "ctl",
					name: "",
					formatCell: (td, v, row) => {
						td.gwCreateChild({
							nodeName: 'a',
							href: row?.product_url,
							target: "_blank",
							className: 'button primary small icon-only' + (!row?.product_url ? ' vhidden' : ''),
							title: _('Otevřít stránku produktu'),
							children: [Utils.useIcon('globe')],
						});
						td.gwCreateChild({
							nodeName: 'button',
							type: 'button',
							className: 'button error-secondary small icon-only',
							'on:click': (e) => {
								new Main.ConfirmDialog({
									title: _('Smazat tuto položku z hardware ceníku?'),
									subtitle: _('Položku lze opětovně přidat přidáním jejího ID produktu.'),
									async onSave() {
										return await REST.DELETE('prices-hardware/' + row.id);
									},
									'on:aftersave': () => {
										this.reloadPrices();
									},
								});
							},
							title: _('Smazat'),
							children: [Utils.useIcon('delete')],
						});
					},
				}],
			}],
		}, this);

		this.reloadPrices();
	},
})

GW.define('PriceChange.Screen', 'Main.Screen', {

	'after:initComponent'() {
		this.titleEl.textContent = _('Změna cen');
		this.bodyEl.gwCreateChild({
			className: 'page-wrapper',
			children: [{
				className: 'page-heading',
				children: [{
					nodeName: 'h1',
					className: 'h2 main-title',
					textContent: _('Změna jednotkových cen'),
				}],
			}, {
				xtype: 'Widgets.TabbedCardPanel',
				ref: 'cards',
				getTabs: () => [...env.PRODUCTS.map(product => ({
					id: product.id,
					title: product.name,
					card: {
						xtype: 'PriceChange.Table',
						product: product.id,
					},
				})), {
					id: 'hardware',
					title: _('Hardware'),
					card: {
						xtype: 'PriceChange.Hardware',
					}
				}],
			}],
		}, this);
	},

	async applyParams(params) {
		this.cards.applyParams(params);
	},

});

// }}}

// {{{ NewExchange.Screen

GW.define('NewExchange.Screen', 'MultiStep.Screen', {
	title: _('Nová ústředna'),
	hideButtons: true,

	async getSteps() {
		const me = this;

		const nums = await REST.GET('available-numbers');

		return [{
			name: _('Zákazník'),
			onBack: () => {
				if (history.length > 1) {
					history.back();
				} else {
					Application.pushRoute(APP_BASE + 'pbxs');
				}
				return true;
			},
			component: {
				id: 'step1',
				xtype: 'FormFieldsGroup',
				renderFormFields() {
					return [{
						className: 'panel-container',
						children: [{
							nodeName: 'h3',
							textContent: _('Vyplňte údaje ústředny'),
						}, {
							xtype: 'TextField',
							name: 'company_name',
							label: _('Název firmy'),
							autofocus: true,
							// value: 'Název firmy ---placeholder---',
						}, {
							ref: 'domainField',
							xtype: 'TextField',
							name: 'domain_name',
							label: _('Doména'),
							placeholder: ' ',
							// value: 'domena-placeholder',
							'on:change': (v) => {
								v.input.value = v.input.value.normalize("NFKD").replace(/\p{Diacritic}/gu, "").replace(/\s|[^a-zA-Z0-9-]/g, "-").replace(/--+/g, '-').replace(/^-+|-+$/g,'').toLowerCase().trim();
							},

							'on:blur'() {
								if (!this.validate()) {
									return;
								}

							},

							'after:initComponent'() {
								this.el.classList.add('form-field-with-suffix');
								this.inputCt.gwCreateChild({
									nodeName: 'span',
									textContent: '.tmbc4.cloud',
									className: 'suffix',
								})
							}
							
						}, {
							xtype: 'SpinnerField',
							name: 'cpus',
							label: _('Počet CPU'),
							value: 1,
							step: 1,
							min: 0,
							disabled: true,
							thousandSeparation: true,
						}, {
							xtype: 'SpinnerField',
							name: 'ram_gb',
							label: _('Velikost RAM (GB)'),
							value: 1,
							step: 1,
							min: 0,
							disabled: true,
							thousandSeparation: true,
						}, {
							xtype: 'SpinnerField',
							name: 'sys_disk_gb',
							label: _('Velikost systémového disku (GB)'),
							value: 10,
							step: 10,
							min: 0,
							disabled: true,
							thousandSeparation: true,
						}, {
							xtype: 'SpinnerField',
							name: 'rec_disk_gb',
							label: _('Velikost disku pro nahrávky (GB)'),
							value: 10,
							step: 10,
							min: 0,
							disabled: true,
							thousandSeparation: true,
						}, {
							className: 'form-buttons fixed',
							children: [{
								nodeName: 'button',
								type: 'button',
								className: 'button secondary icon-left',
								children: [Utils.useIcon('arrow-simple-left'), _('Zpět')],
								'on:click': (ev) => {
									ev.preventDefault();
									me.previousStep();
								},
							}, {
								nodeName: 'button',
								className: 'button icon-right primary ml-auto',
								type: 'button',
								children: [_('Pokračovat'), Utils.useIcon('arrow-simple-right')],
								'on:click': async ev => {
									if (!this.validateForm()) {
										const firstError = this.el.querySelector('.form-field.error');
										if (firstError) {
											firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
											setTimeout(() => {
												firstError.querySelector('input')?.focus();
											}, 500);
										}
										return;
									}
									const formData = this.getFormFieldsData();

									// validate domain name
									formData.domain_name = formData.domain_name + '.tmbc4.cloud';

									try {
										await REST.GET('pbxes/domain-available', {domain: formData.domain_name});
									} catch (e) {
										console.log(e);
										this.domainField.setError(e.serverError);
										return;
									}

									me.formData = {...me.formData, ...formData};
									me.nextStep();
								},
							}],
						}]
					}];
				},
			},
		}, {
			name: _('Čísla'),
			component: {
				id: 'step2',
				xtype: 'FormFieldsGroup',
				selected: new Set(),

				'after:initComponent'() {
					this.updateCheckboxes();

					const autofocusEl = this.el.querySelector('input[autofocus]')
					if (autofocusEl) {
						setTimeout(()=>{
							autofocusEl.focus();
						}, 100)
					}
				},

				renderFormFields() {
					return [{
						className: 'panel-container setup-numbers',
						children: [{
							nodeName: 'h3',
							textContent: _('Vyberte čísla pro novou ústřednu'),
						}, {
							nodeName: 'input',
							type: 'search',
							placeholder: _('Hledat čísla'),
							className: 'small',
							autofocus: true,
							'on:input': ev => {
								this.filter = ev.target.value;
								this.updateCheckboxes();
							},
						}, {
							xtype: 'CheckboxGroup',
							ref: 'checkboxes',
							name: 'numbers',
							optional: false,
							'on:change': ev => {
								const numbersCount = ev.getValue().length;
								if (numbersCount) {
									this.nextButton.textContent = _n(numbersCount, 'Pokračovat s {n} čísly');
									this.nextButton.parentElement.disabled = false;
								} else {
									this.nextButton.textContent = _('Pokračovat');
									this.nextButton.parentElement.disabled = true;
								}
							}
						}, {
							className: 'form-buttons fixed',
							children: [{
								nodeName: 'button',
								className: 'button icon-left secondary',
								type: 'button',
								children: [Utils.useIcon('arrow-simple-left'), _('Zpět')],
								'on:click': ev => me.previousStep(),
							}, {
								nodeName: 'button',
								className: 'button icon-right primary ml-auto',
								type: 'button',
								children: [{ textContent: _('Pokračovat'), ref: 'nextButton' }, Utils.useIcon('arrow-simple-right')],
								disabled: true,
								'on:click': ev => {
									this.updateCheckboxes();
									me.formData.numbers = [...this.selected];
									me.nextStep();
								},
							}],
						}],
					}];
				},

				updateCheckboxes() {
					// XXX: this part is pretty ugly
					const checked = new Set(this.checkboxes.getValue());
					for (let option of this.checkboxes.options) {
						if (checked.has(option.value)) {
							this.selected.add(option.value);
						} else {
							this.selected.delete(option.value);
						}
					}

					let filtered = this.filter ? nums.filter(n => n.includes(this.filter)) : nums;
					this.checkboxes.setOptions(filtered.map(n => ({text: n, value: n})));

					this.checkboxes.setValue([...this.selected]);
				},
			},
		}, {
			name: _('Uživatelé'),
			component: {
				id: 'step3',
				initComponent() {
					this.el = document.gwCreateElement({
						className: 'form-fields-group',
						children: [{
							className: 'panel-container setup-users',
							children: [{
								nodeName: 'h3',
								textContent: _('Založte uživatele ústředny'),
							}, {
								ref: 'accountFields',
								className: 'account-fields',
								children: [{
									xtype: 'UserAccountFieldGroup',
									forceRole: 'superadmin',
								}]
							}, {
								nodeName: 'button',
								type: 'button',
								className: 'button secondary icon-left small button-block',
								children: [Utils.useIcon('plus'), _('Přidat uživatele')],
								'on:click': () => {
									this.accountFields.gwCreateChild({
										xtype: 'UserAccountFieldGroup',
										number: this.accountFields.children.length + 1,
										deletable: true,
										'after:initComponent': () => {
											setTimeout(() => {
												const lastAddedEl = Array.from(this.accountFields.children).at(-1);
												lastAddedEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
												setTimeout(() => {
													lastAddedEl.querySelector('input')?.focus();
												}, 500);
											}, 0);
										},
										'after:destroy': () => {
											let n = 1;
											for (let accountField of this.accountFields.children) {
												accountField.gwComponent.setNumber(n++);
											}
										},
									});
								}
							}, {
								className: 'form-buttons fixed',
								children: [{
									nodeName: 'button',
									className: 'button icon-left secondary',
									type: 'button',
									children: [Utils.useIcon('arrow-simple-left'), _('Zpět')],
									'on:click': ev => me.previousStep(),
								}, {
									nodeName: 'button',
									className: 'button icon-right primary ml-auto',
									type: 'button',
									children: [_('Vytvořit ústřednu'), Utils.useIcon('magic')],
									'on:click': ev => {
										const users = [];
										const emails = new Set();

										let valid = true;

										for (let accountField of this.accountFields.children) {
											accountField = accountField.gwComponent;

											if (!accountField.validateForm()) {
												valid = false;
												continue;
											}

											const userData = accountField.getFormFieldsData();

											const mail = userData.email.toLowerCase().normalize().trim();

											if (emails.has(mail)) {
												accountField.emailField.setError(_('Tento e-mail je uveden u jiného uživatele'));
												valid = false;
												continue;
											} else {
												emails.add(mail);
											}

											users.push(userData);
										}

										if (valid) {
											me.formData.users = users;

											Application.show({
												xtype: 'ExchangeSubmitted.Screen',
												form: me.formData,
											});
										} else {
											const firstError = this.accountFields.querySelector('.form-field.error');
											if (firstError) {
												firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
												setTimeout(() => {
													firstError.querySelector('input')?.focus();
												}, 500);
											}
										}
									},
								}],
							}]
						}]
					}, this);
				},
				'after:initComponent'() {
					// Needed for autofocus while navigating via Application.pushRoute
					const autofocusEl = this.el.querySelector('input[autofocus]')
					if (autofocusEl) {
						setTimeout(()=>{
							autofocusEl.focus();
						}, 100)
					}
				},
			},
		}];
	},
});

// }}}

// {{{ UserAccountFieldGroup

GW.define('UserAccountFieldGroup', 'FormFieldsGroup', {
	number: 1,
	deletable: false,
	forceRole: null,

	renderFormFields() {
		return [{
			className: 'header',
			children: [{
				ref: 'headerEl',
				nodeName: 'h6',
				className: 'title',
				textContent: _('Uživatel {n}').replace('{n}', this.number),
			}, {
				ref: 'tag',
				className: 'tag',
				textContent: this.forceRole ? _('Superadmin') : undefined,
			}, {
				':skip': !this.deletable,
				nodeName: 'button',
				className: 'button secondary icon-only small ml-auto',
				type: 'button',
				children: [Utils.useIcon('delete')],
				'on:click': () => this.destroy(),
			}]
		}, {
			xtype: 'TextField',
			label: _('Jméno'),
			name: 'name',
			extraClass: 'small',
			autofocus: true,
			ref: 'nameField',
		}, {
			ref: 'emailField',
			xtype: 'TextField',
			label: _('E-mail'),
			name: 'email',
			type: 'email',
			extraClass: 'small',
			'on:change': (e) => {
				e.input.value = e.input.value.replace(/\s+/);
			},
		}, {
			xtype: 'PasswordTextField',
			label: _('Heslo'),
			name: 'password',
			extraClass: 'small',
			autocomplete: 'new-password',
		}, {
			xtype: 'SelectField',
			extraClass: 'small',
			name: 'role',
			label: _('Role'),
			submitWhenDisabled: true,
			options: [{
				text: _('Superadmin'),
				value: 'superadmin',
			}, {
				text: _('Admin'),
				value: 'admin',
			}],
			value: this.forceRole,
			disabled: !!this.forceRole,
			'on:change': (e) => {
				this.tag.textContent = e.getValue() === 'superadmin' ? _('Superadmin') : undefined;
			}
		}]
	},

	setNumber(n) {
		this.number = n;
		this.headerEl.textContent = _('Uživatel {n}').replace('{n}', this.number);
	},
});

// }}}

GW.define('ExchangeSubmitted.Screen', 'Main.Screen', {
	'after:initComponent'() {
		this.titleEl.textContent = _('Nová ústředna');
		this.bodyEl.gwCreateChild({
			className: 'page-wrapper',
			children: [{
				nodeName: 'img',
				src: APP_BASE + 'img/exchange-create.svg',
				className: 'illustration',
		}, {
				nodeName: 'h4',
				className: 'title',
				textContent: _('Tříkrát hurá, vaše ústředna se vytváří!'),
				ref: 'titleEl'
			}, {
				className: 'status-list',
				children: [{
					ref: 'statusInstall',
					className: 'status-item',
					children: this.getStatus('requested', _('Instalace ústředny')),
				//}, {
				//	ref: 'statusSetup',
				//	className: 'status-item',
				//	children: this.getStatus('requested', _('Nastavení ústředny')),
				// }, {
				// 	ref: 'statusFinish',
				// 	className: 'status-item',
				// 	children: this.getStatus('requested', _('Odeslání přihlašovacích údajů')),
				}]
			}, {
				className: 'nav-buttons',
				children: [{
					nodeName: 'button',
					className: 'button icon-left secondary',
					type: 'button',
					children: [Utils.useIcon('list'), _('Seznam ústředen')],
					'on:click': ev => {
						Application.pushRoute(APP_BASE + 'pbxs');
					},
				}, {
					nodeName: 'button',
					className: 'button icon-left secondary',
					type: 'button',
					children: [Utils.useIcon('plus'), _('Založit další ústřednu')],
					'on:click': ev => {
						Application.replaceRoute(APP_BASE + 'pbxs/create');
					},
				}, {
					nodeName: 'button',
					type: 'button',
					className: 'button icon-right primary',
					children: [_('Přejít na nově vytvořenou ústřednu'), Utils.useIcon('freepbx')],
					disabled: true,
					ref: 'openExchangeButton',
					'on:click': () => window.open(`http://${this.form.domain_name}/`, this.form.domain_name),
				}],
			}]
		}, this);

		this.createExchange(this.form);
	},

	processComplete() {
		this.openExchangeButton.disabled = false;
		this.titleEl.textContent = _('Vaše ústředna byla úspešně vytvořena!');

		const cs = getComputedStyle(document.documentElement);
		const color1 = cs.getPropertyValue('--primary');
		const color2 = cs.getPropertyValue('--primary-hover');
		const color3 = cs.getPropertyValue('--secondary-active');
		
		confetti({
			gravity: 1,
			particleCount: 300,
			startVelocity: 55,
			spread: 160,
			angle: 90,
			origin: {
				x: 0.5,
				y: 0.6,
			},
			colors: [
				color1,
				color2,
				color3,
			]
		});
	},

	getStatus(status, text) {
		let icon, iconClassName, message;
		switch (status) {
			case 'requested':
			case 'inprogress':iconClassName = 'loading'; 	icon = 'loading';  							break;
			case 'realized': 	iconClassName = 'success'; 	icon = 'checkmarkcirclefilled'; break;
			case 'failed': 		iconClassName = 'error'; 		icon = 'error'; 								message = `selhala ☹`; break;
			// case 'warning':   iconClassName = 'warning'; 	icon = 'warningtrianglefilled'; message = '(převaděč spojitosti 404)'; break;
			default: 					iconClassName = 'info'; 		icon = 'helpcircle';  					message = `(unknown status: '${status})'`
		}
		return [Utils.useIcon(icon, {cls: iconClassName}), {nodeName: 'span', textContent: text}, {textContent: message, className: 'text-error'}];
	},

	async createExchange(form) {
		this.createdPbx = await REST.POST('pbxes', form);
		Utils.interval(this, 'updateStatus', 2000, () => this.updateStatus());
	},

	async updateStatus() {
		const state = await REST.GET('pbxes/' + this.createdPbx.id + '/state');

		this.statusInstall.gwReplaceChildren(this.getStatus(state.state, this.statusInstall.querySelector('span').textContent));

		if (state.state == 'realized' || state.state == 'failed') {
			// handle terminal states
			Utils.abortInterval(this, 'updateStatus');

			if (state.state == 'realized') {
				this.processComplete();
			}
		}
	}
});

// {{{ ExchangeListing.Screen

GW.define('ExchangeListing.Screen', 'Main.Screen', {
	async getData() {

		let params = new URLSearchParams(location.search);
		const q = params.get('q');

		if (q && !this.searchEl.value) {
			this.searchEl.value = GW.htmlEncode(q);
		}

		let pbxes = [];
		try {
			pbxes = await REST.GET('pbxes' + (q ? '?q=' + encodeURIComponent(q) : '') );
		} catch (e) {
			console.error(e);
		}
		this.listingTable.setData(pbxes);
	},

	'after:initComponent'() {
		this.titleEl.textContent = _('Ústředny');
		this.bodyEl.gwCreateChild({
			className: 'page-wrapper',
			children: [{
				className: 'page-heading gap',
				children: [{
					nodeName: 'h1',
					className: 'h2 main-title',
					textContent: _('Přehled ústředen'),
				}, {
					ref: 'searchEl',
					nodeName: 'input',
					autofocus: true,
					type: 'search',
					placeholder: _('Hledat dle firmy, domény, roku'),
					className: 'small',
					style: {"width": "220px", "max-width": "100%", "background-color": "var(--panel-bg)", "margin-left": "auto"},
					'on:input': ev => {
						Utils.dedupeCalls(this, 'setQuery', 300, () => {
							Application.route({
								paramsFn: params => {
									params.set('q', ev.target.value);
									return params;
								},
							});
							this.getData();
						});
					},
				}, {
					className: 'page-heading-controls',
					children: [{
						':skip': !Application.userHasPermission('pbxs.create'),
						nodeName: 'button',
						type: 'button',
						className: 'button primary small icon-left',
						children: [Utils.useIcon('plus'), _('Nová ústředna')],
						'on:click': () => {
							Application.pushRoute(APP_BASE + 'pbxs/create');
						},
					}]
				}]
			}, {
				xtype: 'SmartTable',
				extraClass: 'table-alternative',
				ref: 'listingTable',
				emptyText: _('Žádná odpovídající ústředna nebyla nalezena'),
				getColumns() {
					return [{
						id: "company_name",
						name: _("Firma"),
					}, {
						id: "domain_name",
						name: _("Doména"),
						formatCell(td, v, row) {
							td.gwCreateChild({
								nodeName: 'a',
								href: 'http://'+v,
								target: '_blank',
								textContent: v,
							});
						},
					}, {
						id: "created",
						name: _("Vytvořeno"),
						format: 'date_or_datetime',
					}, {
						id: "number_count",
						name: _("Čísla"),
					}, {
						id: "user_count",
						name: _("Uživatelé"),
					}, {
						id: 'state',
						name: _('Stav'),
						formatCell(td, v, row) {
							let [icon, config, text] = {
								'requested': ['warningtrianglefilled', {cls: 'warning'}, _('Vyžádaná (realizace nezačala)')],
								'inprogress': ['loading', {cls: 'loading'}, _('Probíhá instalace')],
								'complete': ['checkmarkcirclefilled', {cls: 'success'}, _('Zrealizovaná')],
								'failed': ['error', {cls: 'error'}, _('Chyba při instalaci')],
							}[v] || ['helpcircle', {cls: 'info'}, _('Naznámý stav "{stav}"').replace('{stav}', v)];

							td.gwCreateChild(Utils.useIcon(icon, config));
							td.title = text;
						},
					}];
				},
			}],
		}, this);

		this.getData();
	},
});

// }}}
// {{{ Documents.Screen

GW.define('Documents.Screen', 'Main.Screen', {
	
	folder: null, // need to be set

	async getData() {
		const folder = await REST.GET(`documents/folders/${this.folder}`)

		this.titleEl.textContent = folder.name;
		this.listingTable.setData(folder.files);
		this.listingTable.el.classList.remove('hidden');
	},

	'after:initComponent'() {
		this.titleEl.textContent = _('Dokumenty'); // overridden in getData()
		const me = this; 
		this.bodyEl.gwCreateChild({
			className: 'page-wrapper',
			children: [{
				className: 'page-heading',
				children: [{
					nodeName: 'h1',
					className: 'h2 main-title',
					ref: 'titleEl',
				}, {
					':skip': !Application.userHasPermission('documents.admin'),
					className: 'page-heading-controls mb-4',
					children: [{
						nodeName: 'button',
						className: 'primary small icon-left',
						children: [Utils.useIcon('plus'), _("Přidat soubor")],
						'on:click': async () => {
							let file = await Uploads.fileSelect('*/*');
							await Uploads.uploadFile(`documents/folders/${me.folder}/files`, file);
							me.getData();
						},
					}],
				}]
			}, {
				xtype: 'SmartTable',
				extraClass: 'table-alternative hidden',
				ref: 'listingTable',
				emptyText: _('Žádné dokumenty'),
				getColumns() {
					return [{
						id: "name",
						name: _("Dokument"),
						formatCell(td, v, row) {
							td.gwCreateChild({
								nodeName: 'a',
								className: 'text-underline-hover',
								href: API_BASE + `documents/folders/${me.folder}/files/${row.id}`,
								target: `document_view_${row.id}`,
								textContent: v.replace(/.pdf$/, ''),
							});
						},
					}, {
						id: "ctl",
						formatCell(td, v, row) {
							td.classList.add('text-right');
							if (Application.userHasPermission('documents.admin')) {
								td.gwCreateChild({
									nodeName: 'button',
									type: 'button',
									className: 'button error-secondary small icon-left',
									'on:click': (e) => {
										me.showDeleteConfirmDialog(row);
									},
									children: [Utils.useIcon('cross'), _('Smazat soubor')],
								});
							}
							td.gwCreateChild({
								nodeName: 'a',
								className: 'button small primary icon-left',
								href: API_BASE + `documents/folders/${me.folder}/files/${row.id}`,
								target: `document_view_${row.id}`,
								children: [Utils.useIcon('export'), _('Otevřít')],
							});
							td.gwCreateChild({
								nodeName: 'a',
								className: 'button small secondary icon-left',
								href: API_BASE + `documents/folders/${me.folder}/files/${row.id}?download=1`,
								children: [Utils.useIcon('download'), _('Stáhnout')],
							});
						},
					}];
				},
			}],
		}, this);

		this.getData();
	},

	showDeleteConfirmDialog(file) {
		const me = this;
		new Main.ConfirmDialog({
			title: _('Smazat soubor?'),
			subtitle: _('Tato akce nelze vzít zpět.'),

			async onSave() {
				await REST.DELETE(`documents/folders/${me.folder}/files/${file.id}`);
			},

			'on:aftersave': (c, data) => {
				me.getData();
			},
		});
	},

});

// }}}
// {{{ UserAdmin.Screen

GW.define('Admin.Users', 'GW.Component', {

	initComponent() {
		const me = this;
		this.el = document.gwCreateElement({
			children: [{
				className: 'page-heading-controls mb-4',
				children: [{
					nodeName: 'button',
					type: 'button',
					className: 'button secondary small icon-left',
					children: [Utils.useIcon('import'), _('Import XLSX')],
					'on:click': async () => {
						const users = await me.importXlsx();

						const result = await REST.POST('users/import', {users});

						this.reload();

						Application.notify({
							kind: 'success',
							text: _('Uživatelé byly úspěšně importováni. Přidáno uživatelů: {created}, upraveno uživatelů: {updated}')
								.replace('{created}', result.created)
								.replace('{updated}', result.updated),
							priority: 5,
							timeout: 5000,
						});
					},
				}, {
					nodeName: 'button',
					type: 'button',
					className: 'button secondary small icon-left',
					children: [Utils.useIcon('export'), _('Export XLSX')],
					'on:click': () => {
						me.exportXlsx(_('Uživatelé'), this.table.rows);
					},
				}, {
					nodeName: 'button',
					type: 'button',
					className: 'button primary small icon-left',
					children: [Utils.useIcon('userplus'), _('Nový uživatel')],
					'on:click': () => {
						me.showEditForm(null);
					},
				}]
			}, {
				ref: 'table',
				xtype: 'SmartTable',
				extraClass: 'table-alternative',
				getColumns() {
					return [{
						id: "name",
						name: _("Jméno"),
					}, {
						id: "email",
						name: _("Login (e-mail)"),
					}, {
						id: "phone",
						name: _("Telefon"),
					}, {
						id: "active",
						name: _("Aktivní"),
						formatCell(td, v, row) {
							td.textContent = Formats.bool(v);
						},
					}, {
						id: "role_name",
						name: _("Role"),
					}, {
						id: 'ctl',
						name: '',
						formatCell(td, v, row) {
							me.renderControlCell(td, row);
						},
					}];
				},
			}]
		}, this);

		this.reload();
	},
	
	...XLSXTableMixin([{
		id: "name",
		name: _("Jméno"),
		width: 24,
	}, {
		id: "email",
		name: _("Login (e-mail)"),
		width: 28,
	}, {
		id: "phone",
		name: _("Telefon"),
		width: 20,
	}, {
		id: "active",
		name: _("Aktivní"),
		width: 8,
		format: 'bool',
	}, {
		id: "role_name",
		name: _("Role"),
		width: 20,
	}]),
	
	async reload() {
		const data = await REST.GET('users');
		this.table.setData(data);
	},

	renderControlCell(td, item) {
		td.gwCreateChild({
			nodeName: 'button',
			className: 'secondary small icon-only',
			type: 'button',
			title: _('Upravit'),
			children: [Utils.useIcon('pencil')],
			'on:click': ev => this.showEditForm(item),
		});
	},

	passwordValidation(component, passwordOptional) {
		const value = component.getValue();
		if (!passwordOptional && component.isEmpty()) {
			return component.requiredErrorMessage;
		}

		if (value && value.length < 3) {
			return _('Heslo musí musí být dlouhé alespoň 3 znaky');
		}
	},

	showEditForm(item) {
		let me = this;
		let dlg = new Main.FormDialog({
			title: item ? _('Úprava uživatele') : _('Nový uživatel'),
			confirmText: item ? _('Upravit') : _('Vytvořit'),

			renderFormFields() {
				return [{
					xtype: 'TextField',
					name: 'name',
					label: _('Jméno'),
				}, {
					xtype: 'TextField',
					name: 'email',
					type: 'email',
					label: _('Login (e-mail)'),
					autocomplete: "off",
				}, {
					xtype: 'TextField',
					name: 'phone',
					type: 'tel',
					label: _('Telefon'),
					optional: true,
					autocomplete: "off",
				}, {
					xtype: 'SelectField',
					name: 'role_id',
					label: _('Role'),
					optional: true,
					async getOptions({signal}) {
						const roles = await REST.GET('roles', null, {signal});
						return [
							{text: 'Nevybráno', value: null},
							...roles.filter(r => r.active).map(r => ({
								value: r.id,
								text: r.name,
							})),
						];
					},
				}, ...(item ? [{
					xtype: 'AckCheckboxField',
					optional: true,
					name: 'active',
					shortText: _('Aktivní'),
				}, {
					xtype: 'PasswordTextField',
					name: 'password',
					label: _('Nové heslo'),
					autocomplete: "new-password",
					optional: true,
					getViolation() {
						return me.passwordValidation(this, true);
					}
				}] : [{
					xtype: 'PasswordTextField',
					name: 'password',
					label: _('Heslo'),
					autocomplete: "new-password",
					getViolation() {
						return me.passwordValidation(this);
					}
				}]), {
					xtype: 'AckCheckboxField',
					optional: true,
					name: 'password_change_required',
					shortText: _('Vynutit změnu hesla po přihlášení'),
					...(!item ? {
						value: true,
						disabled: true,
					} : {}),
				}];
			},

			async onSave(data) {
				if (item) {
					await REST.PUT('users/' + item.id, data);
				} else {
					await REST.POST('users', data);
				}
				await me.reload();
			},
		});

		if (item) {
			dlg.setFormFieldsData(item);
		}

		return dlg;
	},
	
})

GW.define('Admin.Roles', 'GW.Component', {

	initComponent() {
		const me = this;
		this.el = document.gwCreateElement({
			children: [{
				className: 'page-heading-controls mb-4',
				children: [{
					nodeName: 'button',
					type: 'button',
					className: 'button primary small icon-left',
					children: [Utils.useIcon('usersplus'), _('Nová role')],
					'on:click': () => {
						me.showEditForm(null);
					},
				}]
			}, {
				ref: 'table',
				xtype: 'SmartTable',
				extraClass: 'table-alternative',
				getColumns() {
					return [{
						id: "name",
						name: _("Název role"),
					}, {
						id: "description",
						name: _("Popis"),
					}, {
						id: "active",
						name: _("Aktivní"),
						formatCell(td, v, row) {
							td.textContent = Formats.bool(v);
						},
					}, {
						id: 'ctl',
						name: '',
						formatCell(td, v, row) {
							me.renderControlCell(td, row);
						},
					}];
				},
			}]
		}, this);

		this.reload();
	},
	
	async reload() {
		const data = await REST.GET('roles');
		this.table.setData(data);
	},

	renderControlCell(td, item) {
		td.gwCreateChild({
			nodeName: 'button',
			className: 'secondary small icon-only',
			type: 'button',
			title: _('Upravit'),
			children: [Utils.useIcon('pencil')],
			'on:click': ev => this.showEditForm(item),
		});
	},
	
	showEditForm(item) {
		let me = this;
		let dlg = new Main.FormDialog({
			title: item ? _('Úprava role') : _('Nová role'),

			renderFormFields() {
				return [{
					xtype: 'TextField',
					name: 'name',
					label: _('Název role'),
				}, {
					xtype: 'TextareaField',
					name: 'description',
					label: _('Popis'),
					optional: true,
				}, ...(item ? [{
					xtype: 'AckCheckboxField',
					optional: true,
					name: 'active',
					shortText: _('Aktivní'),
				}] : [])];
			},

			async onSave(data) {
				if (item) {
					await REST.PUT('roles/' + item.id, data);
				} else {
					await REST.POST('roles', data);
				}
				await me.reload();
			},
		});

		if (item) {
			dlg.setFormFieldsData(item);
		}

		return dlg;
	},
	
})

GW.define('Admin.Permissions', 'GW.Component', {

	roles: [],

	initComponent() {
		const me = this;
		this.el = document.gwCreateElement({
			children: [{
				ref: 'table',
			}]
		}, this);

		this.reload();
	},
	
	async saveChanges() {
		await REST.PUT('roles/permissions', this.roles.map(role => ({
			role_id: role.id,
			permissions: role.permissions,
		})));
		await this.reload();
	},
	
	async reload() {
		const [roles, budget_categories, menu_items] = await Promise.all([
			REST.GET('roles').then(roles => roles.filter(r => r.active)),
			REST.GET('seller/budget-categories'),
			Main.Menu.getMenuItems(),
		]);
		this.roles = roles;
		const me = this;
		this.table.gwReplaceChildren([{
			className: 'page-heading-controls mb-4',
			children: [{
				nodeName: 'button',
				type: 'button',
				className: 'button icon-left primary small',
				children: [Utils.useIcon('save'), _('Uložit')],
				'on:click': () => {
					me.saveChanges();
				},
			}]
		}, {
			xtype: 'SmartTable',
			extraClass: 'hoverable',
			getColumns: () => [{
				id: 'name',
				name: _('Oprávnění'),
			}, ...roles.map(role => ({
				id: 'role_' + role.id,
				name: role.name,
				formatCell(td, v, row) {
					const permission = row.permission;
					if (!permission) {
						return;
					}
					td.gwCreateChild({
						nodeName: 'input',
						type: 'checkbox',
						disabled: role.is_admin,
						checked: role.is_admin || role.permissions.includes(permission),
						'on:input': e => {
							// TODO dependent permissions
							const permissions = me.roles.find(r => r.id == role.id).permissions;
							if (e.target.checked) {
								if (!permissions.includes(permission)) {
									permissions.push(permission);
								}
							} else {
								let index = permissions.indexOf(permission);
								if (index >= 0) {
									permissions.splice(index, 1);
								}
							}
						},
					});
				},
			}))],
			
			renderRow(tr, row) {
				if (row.cls) {
					tr.classList.add(row.cls);
				}
			},
			
			rows: [{
				name: 'Rozcestník',
				cls: 'header',
			}, ...menu_items.flatMap(menu => menu.items).map(item => ({
				permission: item.permission,
				name: item.title,
			})), {
				name: _('Seznam nabídek'),
				cls: 'header',
			},{
				permission: 'offers.view_budget',
				name: _('Vidí rozpočetku'),
			},{
				permission: 'offers.view_offer',
				name: _('Vidí nabídku'),
			},{
				permission: 'offers.view_all',
				name: _('Vidí všechny rozpočetky a nabídky'),
			},{
				name: _('Rozpočetka'),
				cls: 'header',
			}, ...budget_categories.flatMap(budget_category => [{
				cls: 'budget_header',
				permission: 'budget.view.' + budget_category.id,
				name: _(budget_category.name),
			}, {
				cls: 'budget_item',
				permission: 'budget.cost_price.' + budget_category.id,
				name: _('Nákladová cena'),
			}, {
				cls: 'budget_item',
				permission: 'budget.sell_price.' + budget_category.id,
				name: _('Prodejní cena'),
			}, {
				cls: 'budget_item',
				permission: 'budget.zero_items.' + budget_category.id,
				name: _('Zobrazovat nulové položky'),
			}])]
		}]);
	},

})

GW.define('UserAdmin.Screen', 'Main.Screen', {
	async getData() {
		this.listingTable.setData(await REST.GET('pbxes'));
	},

	'after:initComponent'() {
		this.titleEl.textContent = _('Správa uživatelů, rolí a oprávnění');
		this.bodyEl.gwCreateChild({
			className: 'page-wrapper',
			children: [{
				className: 'page-heading',
				children: [{
					nodeName: 'h1',
					className: 'h2 main-title mb-3',
					textContent: _('Správa uživatelů, rolí a oprávnění'),
				}]
			}, {
				xtype: 'Widgets.TabbedCardPanel',
				ref: 'cards',
				getTabs() {
					return [{
						id: 'users',
						title: _('Uživatelé'),
						icon: 'user',
						iconActive: 'userfilled',
						card: {
							xtype: 'Admin.Users',
						},
					}, {
						id: 'roles',
						title: _('Role'),
						icon: 'users',
						iconActive: 'usersfilled',
						card: {
							xtype: 'Admin.Roles',
						},
					}, {
						id: 'permissions',
						title: _('Oprávnění'),
						icon: 'lock',
						iconActive: 'unlockfilled',
						card: {
							xtype: 'Admin.Permissions',
						},
					}];
				},
			}],
		}, this);
	},


	async applyParams(params) {
		this.cards.applyParams(params);
	},
});


// }}}
// {{{ DocumentAdmin.Screen

GW.define('Admin.Documents.Folders', 'GW.Component', {

	initComponent() {
		const self = this;
		this.el = document.gwCreateElement({
			children: [{
				className: 'page-heading',
				children: [{
					nodeName: 'h3',
					textContent: _('Složky'),
				}, {
					className: 'page-heading-controls mb-4',
					children: [{
						nodeName: 'button',
						className: 'primary small icon-left',
						children: [Utils.useIcon('plus'), _("Přidat složku")],
						'on:click': async () => {
							self.showEditDialog(null);
						},
					}],
				}],
			}, {
				ref: 'table',
				xtype: 'SmartTable',
				getColumns: () => [{
					id: 'id',
					name: _('ID'),
				}, {
					id: 'name',
					name: _('Název složky'),
				}, {
					id: 'ctl',
					formatCell: (td, v, row) => {
						td.gwCreateChild({
							nodeName: 'button',
							type: 'button',
							className: 'button secondary small icon-left',
							'on:click': (e) => {
								self.showEditDialog(row);
							},
							children: [Utils.useIcon('pencil'), _('Přejmenovat')],
						});

						td.gwCreateChild({
							nodeName: 'button',
							type: 'button',
							className: 'button error-secondary small icon-left',
							'on:click': (e) => {
								self.showDeleteConfirmDialog(row);
							},
							children: [Utils.useIcon('cross'), _('Smazat složku')],
						});

						td.gwCreateChild({
							nodeName: 'button',
							type: 'button',
							className: 'button primary small icon-left',
							'on:click': (e) => {
								Application.pushRoute(APP_BASE + 'documents/' + row.id);
							},
							children: [Utils.useIcon('documentwithcontent'), _('Spravovat soubory')],
						});
					}
				}],
			}]
		}, this);

		this.reload();
	},
	
	showEditDialog(folder) {
		let me = this;

		let dlg = new Main.FormDialog({
			title: folder ? _('Úprava složky') : _('Nová složka'),

			renderFormFields() {
				return [{
					xtype: 'TextField',
					name: 'name',
					label: _('Název složky'),
					autofocus: true,
				}];
			},

			async onSave(data) {
				if (folder) {
					return REST.PUT(`documents/folders/${folder.id}`, data);
				} else {
					return REST.POST(`documents/folders`, data);
				}
			},
			
			'on:aftersave'() {
				me.reload();
				Main.Menu.invalidate();
			},
		});

		if (folder) {
			dlg.setFormFieldsData(folder);
		}
	},

	showDeleteConfirmDialog(folder) {
		const me = this;
		new Main.ConfirmDialog({
			title: _('Smazat složku včetně všech souborů?'),
			subtitle: _('Tato akce nelze vzít zpět.'),

			async onSave() {
				await REST.DELETE(`documents/folders/${folder.id}`);
				Main.Menu.invalidate();
			},

			'on:aftersave': (c, data) => {
				me.reload();
			},
		});
	},

	async reload() {
		const folders = await REST.GET('documents/folders');
		this.table.setData(folders);
	},
	
	applyParams() {
		this.reload();
	}

})

GW.define('DocumentAdmin.Screen', 'Main.Screen', {

	'after:initComponent'() {
		this.titleEl.textContent = _('Správa dokumentů');
		this.bodyEl.gwCreateChild({
			className: 'page-wrapper',
			children: [{
				className: 'page-heading',
				children: [{
					nodeName: 'h1',
					className: 'h2 main-title mb-3',
					textContent: _('Správa dokumentů'),
				}]
			}, {
				xtype: 'Admin.Documents.Folders',
				ref: 'content',
			}],
		}, this);
	},


	async applyParams(params) {
		this.content.applyParams(params);
	},
});


// }}}

// {{{ Routes

Application.addRoutes([{
	group: 'public',
	path: APP_BASE,
	async handler() {
		if (!Application.session || !Application.session.user) {
			await Application.replaceRoute(APP_BASE + 'login');
			return;
		}
		await Application.replaceRoute(APP_BASE + 'dashboard');
	}    
}, {
	group: 'public',
	path: APP_BASE + 'reset-password/{rest:rest}',
	async handler({ params, captures }) {
		Application.show({
			id: 'main.passwordreset',
			xtype: 'Pubweb.ResetPasswordFinish',
			token: captures?.rest,
		});
	}    
}, {
	// public route for headless browser for converting the offer to PDF
	group: 'public',
	path: APP_BASE + 'public/offers/{rest:rest}',
	async handler({ params, captures }) {
		const uuid = captures?.rest;
		Application.show({
			xtype: 'PublicOfferPrintDetail.Screen',
			offerPublicId: uuid,
		});
	}
}, {
	group: 'auth',
	path: APP_BASE + 'dashboard',
	async handler({ params }) {
		Application.show({
			id: 'main.modulesscreen',
			xtype: 'Main.ModulesScreen',
		});
	}
}, {
	group: 'auth',
	permission: 'offers.list',
	path: APP_BASE + 'offers',
	async handler({ params }) {
		Application.show({
			id: 'offerlisting.screen',
			xtype: 'OfferListing.Screen',
		});
	}    
}, {
	group: 'auth',
	permission: 'pbxs.list',
	path: APP_BASE + 'pbxs',
	async handler({ params }) {
		Application.show({
			id: 'exchangelisting.screen',
			xtype: 'ExchangeListing.Screen',
		});
	}    
}, {
	group: 'auth',
	path: APP_BASE + 'offers/create',
	async handler({ params }) {
		const product = params.get('product');
		const offerId = params.get('offerId');
		Application.requirePermission('offers.create.' + product)
		Application.show({
			xtype: 'NewOffer.Screen',
			product,
			offerId
		});
	}    
}, {
	group: 'auth',
	permission: 'offers.view_offer',
	path: APP_BASE + 'offers/{rest:rest}',
	async handler({ params, captures }) {
		const id = captures?.rest;
		Application.show({
			xtype: 'OfferDetail.Screen',
			offerId: id,
		});
	}    
}, {
	group: 'auth',
	permission: 'offers.view_budget',
	path: APP_BASE + 'budget/{rest:rest}',
	async handler({ params, captures }) {
		const id = captures?.rest;
		Application.show({
			xtype: 'Budget.Screen',
			offerId: id,
		});
	}    
}, {
	group: 'auth',
	permission: 'pbxs.create',
	path: APP_BASE + 'pbxs/create',
	async handler({ params, captures }) {
		Application.show({
			xtype: 'NewExchange.Screen',
		});
	}    
}, {
	group: 'auth',
	permission: 'prices.edit',
	path: APP_BASE + 'prices',
	async handler({ params, captures }) {
		let c = Application.show({
			xtype: 'PriceChange.Screen',
		});
		c.applyParams(params);
	}    
}, {
	group: 'auth',
	permission: 'users.admin',
	path: APP_BASE + 'users',
	async handler({ params, captures }) {
		let c = Application.show({
			xtype: 'UserAdmin.Screen',
		});
		c.applyParams(params);
	}    
}, {
	group: 'auth',
	permission: 'documents.admin',
	path: APP_BASE + 'documents',
	async handler({ params, captures }) {
		let c = Application.show({
			xtype: 'DocumentAdmin.Screen',
		});
		c.applyParams(params);
	}    
}, {
	group: 'auth',
	path: APP_BASE + 'documents/{rest:rest}',
	async handler({ params, captures }) {
		const folder = captures?.rest;
		Application.requirePermission('documents.folder.' + folder);
		let c = Application.show({
			xtype: 'Documents.Screen',
			folder
		});
	}
}]);

// }}}
